import qoutes from "../components/Quotes";
import idea from "../images/idea.png";
import { useRecordWebcam } from "react-record-webcam";
import { ThreeDots } from "react-loader-spinner";
import axios from "axios";
import React, { useState, useEffect } from "react";
import testpic1 from "../images/test_pic1.png";
import testpic2 from "../images/test_pic2.png";
import { Link, useLocation } from "react-router-dom";
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import { CiMicrophoneOn } from "react-icons/ci";
import { PiMicrophone } from "react-icons/pi";
import { IoIosArrowDown } from "react-icons/io";
import { HiOutlineVideoCamera } from "react-icons/hi2";
import uuid from "react-uuid";
import "video.js/dist/video-js.min.css";
import { MediaPermissionsErrorType, requestMediaPermissions } from "mic-check";
import { TbPlayerRecordFilled } from "react-icons/tb";
import ReactStars from "react-stars";
import sia_face from "../images/sia_face.png";
import { isSafari } from "react-device-detect";
import ReactQuill from "react-quill";
import { data1 } from "../config";
import { server_API } from "../config";
import TextToSpeech from "../components/TextToSpeech";
import { translations } from "./translation";
import { IoMdArrowBack } from "react-icons/io";
import Copyright from "./Copyright";
import { getCurrencySymbol, getPhoneCode } from "../utils/currencyUtils";

function Data() {
  const recordWebcam = useRecordWebcam({
    frameRate: 60,
    // height: 500,
    // width: 480,
  });
  const [audioDevices, setAudioDevices] = useState([]);
  const [videoDevices, setVideoDevices] = useState([]);
  const [selectedAudioDevice, setSelectedAudioDevice] = useState(null);
  const [selectedVideoDevice, setSelectedVideoDevice] = useState(null);
  const [showAudioDropdown, setShowAudioDropdown] = useState(false);
  const [showVideoDropdown, setShowVideoDropdown] = useState(false);
  const [progress, setProgress] = useState();
  const [currentStep, setCurrentStep] = useState(1);

  const [jid, setJid] = useState("");
  const [id, setId] = useState("");
  const [logo, setLogo] = useState("");
  const [firstinterview, setFirstInterview] = useState(null);
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const [language, setLanguage] = useState("EN");
  const [prefLanguage, setPrefLanguage] = useState("");
  const [introVa, setIntroVa] = useState(0);
  const [ctVa, setCtVa] = useState(0);
  const [gmVa, setGmVa] = useState(0);
  const [lsVa, setLsVa] = useState(0);
  const [twVa, setTwVa] = useState(0);
  const [createdOn, setCreatedOn] = useState(null);
  const [commVa, setCommVa] = useState(0);
  const [langFlag, setLangFlag] = useState(false);
  const [noticePeriod, setNoticePeriod] = useState("");
  const [notes, setNotes] = useState("");
  const [joiningTime, setJoiningTime] = useState("");
  const [expectedSalary, setExpectedSalary] = useState("");
  const [currentSalary, setCurrentSalary] = useState("");
  const [choice5, setChoice5] = useState(0);
  const [compName, setCompName] = useState({});
  const [choice6, setChoice6] = useState(0);
  const [index, setIndex] = useState(0);
  const [comm, setComm] = useState(0);
  const [crit, setCrit] = useState(0);
  const [checked, setChecked] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [leader, setLeader] = useState(0);
  const [team, setTeam] = useState(0);
  const [star, setStar] = useState(0);
  const [intro, setIntro] = useState(0);
  const [grow, setGrow] = useState(0);
  const [status, setStatus] = useState(true);
  const [resScore, setResScore] = useState(0);
  const [isRated, setIsRated] = useState(false);
  const [toi, setToi] = useState("");
  const [ques, setQues] = useState(1);
  const [mcqs, setMcqs] = useState([]);
  const email = localStorage.getItem("email");
  const [loader, setLoader] = useState(true);
  const [qoutesindex, setQoutesIndex] = useState([]);
  const [techArr, setTechArr] = useState([]);
  const [i, setI] = useState(0);
  const [companyId, setCompanyId] = useState("");
  const [j, setJ] = useState(0);
  const [uid, setUid] = useState("");
  const [loader1, setLoader1] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);
  const [stat, setStat] = useState("");
  const [loader4, setLoader4] = useState(false);
  const [loader5, setLoader5] = useState(false);
  const [name, setName] = useState("");
  const [loader6, setLoader6] = useState(false);
  const [loader7, setLoader7] = useState(false);
  const [counter, setCounter] = useState(15);
  const [curr, setCurr] = useState("");
  const [loader8, setLoader8] = useState(false);
  const [techQuestions, setTechQuestions] = useState([]);
  const [hindiQuestions, setHindiQuestions] = useState([]);
  const [feed, setFeed] = useState([]);
  const [visibleVideo, setVisibleVideo] = useState(true);
  const [visibleVideo2, setVisibleVideo2] = useState(true);
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [visible, setvisible] = useState(false);
  const [, updateState] = React.useState();
  const [isDone, setIsDone] = useState(false);
  const [interviews, setInterviews] = useState([]);
  const [timeDiff, setTimeDiff] = useState(null);
  const [jobData, setJobData] = useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const user = localStorage.getItem("email");
  const [showTextarea, setShowTextarea] = useState(false);
  const [textareaContent, setTextareaContent] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [malayTest, setMalayTest] = useState(null);
  const [companyCountryCode, setCompanyCountryCode] = useState("IN");

  const currentTime = new Date();
  const Toggle = ({ language, setLanguage, onColor }) => {
    const toggleLanguage = () => {
      setLanguage((prevLanguage) =>
        prevLanguage == "EN" ? `${prefLanguage}` : "EN"
      );
    };

    return (
      <>
        <div
          className={` items-center gap-2 py-3 px-6 rounded-lg cursor-pointer bg-white ${
            prefLanguage != "EN" ? "flex" : "hidden"
          }`}
        >
          <label
            htmlFor="toggle-en"
            className={`text-gray-900 ${
              language == "EN" ? "font-semibold" : ""
            } `}
          >
            English
          </label>
          <input
            checked={language == prefLanguage}
            onChange={toggleLanguage}
            className="react-switch-checkbox hidden"
            id={`react-switch-new`}
            type="checkbox"
          />
          <label
            style={{ background: language == prefLanguage && onColor }}
            className="react-switch-label"
            htmlFor={`react-switch-new`}
          >
            <span className={`react-switch-button`} />
          </label>
          <label
            htmlFor="toggle-hi"
            className={`text-gray-900 ${
              language == "HI" ? "font-semibold" : ""
            } `}
          >
            {prefLanguage == "HI" ? "Hindi" : "Malay"}
          </label>
        </div>
      </>
    );
  };
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  console.log("question", translations.ques20[language].terms);
  console.log(createdOn);
  useEffect(() => {
    if (createdOn != null) {
      const created = new Date(createdOn);
      let diff = created - currentTime;
      // console.log(diff);
      setTimeDiff(Math.abs(diff));
    }
  }, [createdOn]);

  let query = useQuery();

  React.useEffect(() => {
    if (
      ques >= 2 &&
      // && !langFlag
      ques != 21
    ) {
      const timer =
        counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter, ques, langFlag]);

  console.log(langFlag);

  useEffect(() => {
    if (companyId.length > 0) {
      axios
        .get(`${server_API}/v2/company/geturl/${companyId}`)
        .then((response) => {
          console.log(response);
          setLogo(response.data.url);
        })
        .catch((err) => {
          console.log(err);
        });
      axios
        .get(`${server_API}/v2/applicant/get/${query.get("id")}/${companyId}`)
        .then((response) => {
          setResScore(response.data.resumescore);
          setCreatedOn(response.data.createdat);
          setName(response.data.name);
          setStatus(response.data.status);
          setStat(response.data.status);
          setCountryCode(response.data.countrycode);
          console.log(response);
        });
    }
  }, [companyId]);

  useEffect(() => {
    const email = localStorage.getItem("email");
    setUid(uuid());
    setId(query.get("id"));

    axios
      .get(`${server_API}/v2/applicant/dbcompany/${query.get("id")}`)
      .then((response) => {
        console.log(response, "app");
        // setResScore(response.data.resumescore);
        // setCreatedOn(response.data.createdat)
        // setName(response.data.name);
        setJid(response.data.jobid);
        setCompanyId(response.data.companyid);
        // setStatus(response.data.status)
        // setStat(response.data.status);
        // setCountryCode(response.data.countrycode)
        console.log(response.data.status);
        axios
          .get(`${server_API}/v2/company/get/${response.data.companyid}`)
          .then((response) => {
            setCompName(response.data);
            if (response.data.company_countries && response.data.company_countries.length > 0) {
              const code = response.data.company_countries[0];
              setCompanyCountryCode(code);
              setCurr(getCurrencySymbol(code));
              setCountryCode(getPhoneCode(code));
            }
            axios
              .get(`${server_API}/v2/question/question`)
              .then((response) => {
                console.log("question", response);
                setQuestions(response.data.result);
              })
              .catch((err) => {
                console.log(err);
              });
          })

          .catch((error) => {
            console.log(error);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const patchUser = () => {
    setQues(12);
    axios
      .patch(`${server_API}/v2/applicant/update`, {
        uuid: id,
        companyid: companyId,
        noticeperiod: noticePeriod,
        expectedsalary: `${curr} ${expectedSalary}`,
        currentsalary: `${curr} ${currentSalary}`,
        joiningtime: joiningTime,
        notes: notes,
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (jid.length > 0) {
      axios
        .get(`${server_API}/v2/job/get/${jid}/${companyId}`)
        .then((response) => {
          setJobData(response.data);
          setPrefLanguage(response.data.preferredlanguage);
          console.log(response);
          axios
            .get(
              `${server_API}/v2/question/get/${response.data.questionid}/${companyId}`
            )
            .then((response) => {
              console.log("questions", response);
              setTechQuestions(response.data.questions);
              setHindiQuestions(response.data.hindiquestion);
              setLoader(false);
            })
            .catch((error) => {
              console.log(error);
              setLoader(false);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [jid]);

  console.log(langFlag, language);
  const update = () => {
    console.log("patcing");

    var vaMarks = Math.ceil(
      parseInt((ctVa + twVa + lsVa + gmVa + commVa + introVa) / 6)
    );
    var marks = (crit + team + leader + grow + comm + intro) / 6;
    marks = parseInt(Math.ceil(marks * 20.0));

    if (vaMarks == 0) {
      vaMarks = 1;
      vaMarks = (vaMarks / 10) * 100;
    } else {
      vaMarks = (vaMarks / 10) * 100;
    }

    var tScore = 0;

    if (techArr.length > 0) {
      techArr.map((t) => {
        tScore = tScore + parseInt(t);
      });
    }

    if (techQuestions.length > 0) {
      tScore = Math.ceil(tScore / techQuestions.length);
    }

    axios
      .put(`${server_API}/v2/job/increment/interview/${jid}/${companyId}`)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .patch(`${server_API}/v2/applicant/update`, {
        uuid: id,
        companyid: companyId,
        aiscore: marks,
        voiceanalysisscore: vaMarks,
        status: "Interviewed",
        technicalscore: tScore,
      })
      .then((response) => {
        console.log(response);
        axios
          .post(`${server_API}/v2/applicant/aggregate/update`, {
            //Add company id
            resumescore: resScore,
            companyid: companyId,
            aiscore: marks,
            voicescore: vaMarks,
            technicalscore: tScore,
            applicantid: id,
            jobid: jid,
          })
          .then((response) => {
            console.log(response);
            setLoader8(false);
            setQues(13);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (firstinterview != null) {
      if (firstinterview == false) {
        setToi("free");
      } else if (firstinterview == true) {
        setToi("paid");
      }
    }
  }, [firstinterview]);

  useEffect(() => {
    requestMediaPermissions()
      .then(() => {
        recordWebcam.open();
        navigator.mediaDevices.enumerateDevices().then((devices) => {
          const audioInputs = devices.filter(
            (device) => device.kind === "audioinput"
          );
          const videoInputs = devices.filter(
            (device) => device.kind === "videoinput"
          );
          setAudioDevices(audioInputs);
          setVideoDevices(videoInputs);
          console.log("audio-devices", audioInputs);
          console.log("video-devices", videoInputs);
          setSelectedAudioDevice(audioInputs[0]?.deviceId || null);
          setSelectedVideoDevice(videoInputs[0]?.deviceId || null);
        });
      })
      .catch((error) => {
        const { type, name, message } = error;
        if (type == MediaPermissionsErrorType.SystemPermissionDenied) {
          alert("Please allow permission from system");
        } else if (type == MediaPermissionsErrorType.UserPermissionDenied) {
          alert(
            "You denied the permission in browser, please allow permission from system"
          );
        } else if (type == MediaPermissionsErrorType.CouldNotStartVideoSource) {
          alert(
            "Your video was busy in other places, please close all tabs to enable camera"
          );
        } else {
          console.log(name, message);
          alert("Something went wrong, please try again");
        }
      });
  }, []);
  // useEffect(() => {
  //   recordWebcam.open();
  //   navigator.mediaDevices.enumerateDevices().then(devices => {
  //     const audioInputs = devices.filter(device => device.kind === 'audioinput');
  //     const videoInputs = devices.filter(device => device.kind === 'videoinput');
  //     setAudioDevices(audioInputs);
  //     setVideoDevices(videoInputs);
  //     setSelectedAudioDevice(audioInputs[0]?.deviceId || null);
  //     setSelectedVideoDevice(videoInputs[0]?.deviceId || null);
  //   });
  // }, [recordWebcam]);
  const selectAudioDevice = (deviceId) => {
    setSelectedAudioDevice(deviceId);
    setShowAudioDropdown(false);
  };

  const selectVideoDevice = (deviceId) => {
    setSelectedVideoDevice(deviceId);
    setShowVideoDropdown(false);
  };
  const onlyContainsNumbers = (str) => /^[0-9,.]*$/.test(str);

  const inputNum = (event) => {
    const { value } = event.target;
    // Remove any existing commas from the input
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, "");

      // Format the number with commas

      setNoticePeriod(sanitizedValue);
    } else {
      setNoticePeriod("");
    }
  };

  const approxNum = (event) => {
    const { value } = event.target;
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, "");

      // Format the number with commas

      setJoiningTime(sanitizedValue);
    } else {
      setJoiningTime("");
    }
  };

  const monthlySalary = (event) => {
    const { value } = event.target;
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, "");

      // Format the number with commas

      const formattedValue = Number(sanitizedValue).toLocaleString();

      setCurrentSalary(formattedValue);
    } else {
      setCurrentSalary("");
    }
  };

  const expectedMSalary = (event) => {
    const { value } = event.target;
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, "");

      // Format the number with commas

      const formattedValue = Number(sanitizedValue).toLocaleString();

      setExpectedSalary(formattedValue);
    } else {
      setExpectedSalary("");
    }
  };

  useEffect(() => {
    if (loader8 == true) {
      setInterval(() => {
        var ind = Math.floor(Math.random() * 124);
        setIndex(ind);
      }, 5000);
    }
  }, [loader8]);

  useEffect(() => {
    // Calculate total steps: 6 individual questions + length of techQuestions + 2 (feedback and rating)
    const totalSteps = 6 + techQuestions.length + 2;
    const baseIncrement = Math.floor(100 / totalSteps);

    const updateProgress = () => {
      if (currentStep < totalSteps) {
        setProgress(currentStep * baseIncrement);
      } else {
        setProgress(100);
      }
    };

    updateProgress();
  }, [questions, techQuestions, currentStep]);

  const handleStepsProgress = () => {
    setCurrentStep((prevStep) => prevStep + 1);
  };
  useEffect(() => {
    recordWebcam.open();
    if (recordWebcam.status == "ERROR") {
      alert("Please try again later");
      navigate("/");
    }
  }, [ques]);

  console.log(toi);
  console.log(qoutesindex);

  useEffect(() => {
    console.log(ques);
    if (ques == 2 || ques == 5) {
      setCounter(15);
    }
  }, [ques]);

  const techConnect = async () => {
    setCounter(15);
    handleStepsProgress();
    if (i == techQuestions.length - 1) {
      setLoader8(true);
    }
    if (i < techQuestions.length - 1) {
      setI(i + 1);
    }
    const blob = await recordWebcam.getRecording();
    const data = new FormData();
    recordWebcam.stop();
    setStatus(true);
    data.append("file", blob);
    data.append("questionText", techQuestions[i].Question);
    data.append("questionId", String(i + 1));
    data.append("applicantid", id);
    data.append("interviewid", uid);
    data.append("category", "tech");
    data.append("interviewtype", toi);
    data.append("preferredLang", language);
    data.append("jobid", jid);
    data.append("companyid", companyId);
    data.append("desiredtext", techQuestions[i].Answer);
    // console.log(data);
    axios
      .post(`${server_API}/v2/interview/video?flag=false`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setTechArr((prevValue) => [...prevValue, response.data.tech_score]);
      })
      .catch((error) => {
        console.log(error);
      });
    recordWebcam.open();
  };

  useEffect(() => {
    if (
      i == techQuestions.length - 1 &&
      techArr.length == techQuestions.length
    ) {
      console.log("Patching");
      update();
    }
  }, [i, techArr]);

  console.log(techArr.length);

  useEffect(() => {
    // localStorage.setItem('i',i)
    if (i == 10) {
      setQues(4);
    }
  }, [i]);

  useEffect(() => {
    const handleTabClose = (event) => {
      event.preventDefault();

      console.log("beforeunload event triggered");

      return (event.returnValue = "Are you sure you want to exit?");
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, []);

  const convert = (ans) => {
    if (ans == "Bad") {
      return 1;
    } else if (ans == "Below Average") {
      return 2;
    } else if (ans == "Average") {
      return 3;
    } else if (ans == "Above Average") {
      return 4;
    } else if (ans == "Good") {
      return 5;
    } else if (ans == "Not Answered") {
      return 0;
    }
  };

  const save = (cat, ans, vaScore) => {
    if (cat == "ct") {
      setCrit(crit + convert(ans));
      setCtVa(ctVa + vaScore);
    }
    if (cat == "ls") {
      setLeader(leader + convert(ans));
      setLsVa(lsVa + vaScore);
    }
    if (cat == "tw") {
      setTeam(team + convert(ans));
      setTwVa(twVa + vaScore);
    }
    if (cat == "i") {
      setIntro(intro + convert(ans));
      setIntroVa(introVa + vaScore);
    }
    if (cat == "gm") {
      setGrow(grow + convert(ans));
      setGmVa(gmVa + vaScore);
    }
    if (cat == "c") {
      setComm(comm + convert(ans));
      setCommVa(commVa + vaScore);
    }
  };

  const stop = () => {
    recordWebcam.stop();
    setStatus(false);
  };

  const retake = () => {
    recordWebcam.retake();
    setStatus(true);
  };

  useEffect(() => {
    if (counter == 0 && recordWebcam.status == "OPEN") {
      recordWebcam.start();
    }
  }, [counter, recordWebcam.status]);

  // useEffect(()=>{
  //   forceUpdate()
  // },[crit, team,leader,grow, comm, intro])

  // console.log((crit+ team+leader+grow+ comm+ intro)/5)

  //   useEffect(()=>{
  //     axios.put(`${server_API}/v2/applicant/update`,{})
  //   },[])

  const saveFile1 = async () => {
    const blob = await recordWebcam.getRecording();
    const data = new FormData();
    data.append("file", blob);
    data.append("questionText", questions[0].statement);
    data.append("questionId", questions[0].index);
    data.append("applicantid", id);
    data.append("interviewid", uid);
    data.append("category", questions[0].category);
    data.append("interviewtype", toi);
    data.append("jobid", jid);
    data.append("preferredLang", language);
    data.append("companyid", companyId);
    axios
      .post(`${server_API}/v2/interview/video?flag=false`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        console.log(response.data);
        // // setRank(response.data.result.rank)
        save(
          questions[0].category,
          response.data.score.rank,
          response.data.score.voiceanalysis_score
        );
        setLoader1(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // upload(data, 'i',5)
    setQues(5);

    console.log(intro);
    recordWebcam.open();

    // loader = false
  };

  const saveFile2 = async () => {
    const blob = await recordWebcam.getRecording();
    const data = new FormData();
    data.append("file", blob);
    data.append("questionText", questions[1].statement);
    data.append("questionId", questions[1].index);
    data.append("applicantid", id);
    data.append("interviewid", uid);
    data.append("category", questions[1].category);
    data.append("interviewtype", toi);
    data.append("preferredLang", language);
    data.append("jobid", jid);
    data.append("companyid", companyId);
    axios
      .post(`${server_API}/v2/interview/video?flag=false`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        console.log(response.data);
        // // setRank(response.data.score.rank)

        save(
          questions[1].category,
          response.data.score.rank,
          response.data.score.voiceanalysis_score
        );
        setLoader2(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // upload(data, 'i',6)
    setQues(6);

    recordWebcam.open();
    console.log(blob);
    // loader = false
  };

  const saveFile3 = async () => {
    // loader = true
    const blob = await recordWebcam.getRecording();
    const data = new FormData();
    // forceUpdate()
    data.append("file", blob);
    data.append("questionId", questions[2].index);
    data.append("questionText", questions[2].statement);
    data.append("applicantid", id);
    data.append("interviewid", uid);
    data.append("interviewtype", toi);
    data.append("preferredLang", language);
    data.append("jobid", jid);
    data.append("companyid", companyId);
    data.append("category", questions[2].category);
    axios
      .post(`${server_API}/v2/interview/video?flag=false`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        console.log(response.data);
        // // setRank(response.data.score.rank)

        save(
          questions[2].category,
          response.data.score.rank,
          response.data.score.voiceanalysis_score
        );
        setLoader3(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // upload(data,'i',7)
    setQues(7);

    recordWebcam.open();
    console.log(blob);
    // loader = false
  };

  const saveFile4 = async () => {
    // loader = true
    const blob = await recordWebcam.getRecording();
    const data = new FormData();
    // forceUpdate()
    data.append("file", blob);
    data.append("questionText", questions[3].statement);
    data.append("questionId", questions[3].index);
    data.append("applicantid", id);
    data.append("interviewid", uid);
    data.append("category", questions[3].category);
    data.append("interviewtype", toi);
    data.append("jobid", jid);
    data.append("preferredLang", language);
    data.append("companyid", companyId);
    axios
      .post(`${server_API}/v2/interview/video?flag=false`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        console.log(response.data);
        // // setRank(response.data.score.rank)

        save(
          questions[3].category,
          response.data.score.rank,
          response.data.score.voiceanalysis_score
        );
        setLoader4(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // upload(data, 'c',8)
    setQues(8);

    recordWebcam.open();
    console.log(blob);
    // loader = false
  };
  const saveFile5 = async () => {
    // loader = true
    const blob = await recordWebcam.getRecording();
    const data = new FormData();
    // forceUpdate()
    data.append("file", blob);
    data.append("questionText", questions[4].statement);
    data.append("questionId", questions[4].index);
    data.append("applicantid", id);
    data.append("interviewid", uid);
    data.append("interviewtype", toi);
    data.append("jobid", jid);
    data.append("preferredLang", language);
    data.append("companyid", companyId);
    data.append("category", questions[4].category);
    axios
      .post(`${server_API}/v2/interview/video?flag=false`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        console.log(response.data);
        // // setRank(response.data.score.rank)

        save(
          questions[4].category,
          response.data.score.rank,
          response.data.score.voiceanalysis_score
        );
        setLoader5(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // upload(data, 'l',9)
    setQues(9);
    recordWebcam.open();
    console.log(blob);

    console.log("stop");
    // loader = false
  };

  const saveFile6 = async () => {
    // loader = true
    const blob = await recordWebcam.getRecording();
    const data = new FormData();
    // forceUpdate()
    data.append("file", blob);
    data.append("questionText", questions[5].statement);
    data.append("questionId", questions[5].index);
    data.append("applicantid", id);
    data.append("interviewid", uid);
    data.append("category", questions[5].category);
    data.append("preferredLang", language);
    data.append("interviewtype", toi);
    data.append("jobid", jid);
    data.append("companyid", companyId);
    axios
      .post(`${server_API}/v2/interview/video?flag=false`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        console.log(response.data);
        // // setRank(response.data.score.rank)

        save(
          questions[5].category,
          response.data.score.rank,
          response.data.score.voiceanalysis_score
        );
        setLoader6(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // upload(data,'t',10)
    setQues(10);

    recordWebcam.open();
    console.log(blob);
    // loader = false
  };

  const saveFile8 = async () => {
    // loader = true
    const blob = await recordWebcam.getRecording();
    const data = new FormData();
    console.log(data);
    // forceUpdate()
    data.append("file", blob);
    data.append("questionText", questions[6].statement);
    data.append("questionId", questions[6].index);
    data.append("applicantid", id);
    data.append("interviewid", uid);
    data.append("preferredLang", language);
    data.append("category", questions[6].category);
    data.append("interviewtype", toi);
    data.append("jobid", jid);
    data.append("companyid", companyId);
    axios
      .post(`${server_API}/v2/interview/video?flag=false`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        console.log(response.data);
        // // setRank(response.data.score.rank)

        save(
          questions[6].category,
          response.data.score.rank,
          response.data.score.voiceanalysis_score
        );
        setLoader7(false);
      })
      .catch((error) => {
        console.log(error);
      });
    // upload(data,'g',11)
    setQues(11);

    recordWebcam.open();
    console.log(blob);
    // loader = false
  };

  const saveStar = () => {
    axios
      .patch(`${server_API}/v2/applicant/update`, {
        uuid: id,
        companyid: companyId,
        rating: star,
        feedback: textareaContent,
      })
      .then((response) => {
        console.log(response);
        setIsRated(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveFile9 = async () => {
    // loader = true

    if (techQuestions.length > 0) {
      setQues(2);
    } else {
      setLoader8(true);
    }

    const blob = await recordWebcam.getRecording();
    const data = new FormData();
    // forceUpdate()
    data.append("file", blob);
    data.append("questionText", questions[6].statement);
    data.append("questionId", questions[6].index);
    data.append("applicantid", id);
    data.append("interviewid", uid);
    data.append("interviewtype", toi);
    data.append("preferredLang", language);
    data.append("jobid", jid);
    data.append("companyid", companyId);
    data.append("category", questions[6].category);
    axios
      .post(`${server_API}/v2/interview/video?flag=false`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        save(
          questions[6].category,
          response.data.score.rank,
          response.data.score.voiceanalysis_score
        );
        console.log(response);
        if (techQuestions.length == 0) {
          update();
        }
      })
      .catch((error) => {
        console.log(error);
      });
    recordWebcam.close();
  };

  console.log(recordWebcam.status);
  const nav = () => {
    recordWebcam.close();
    if (star != 0) {
      axios
        .post(`${data1.API}/interview/feedback`, {
          username: user,
          feedback: [star],
        })
        .then((response) => {
          console.log(response);
          navigate("/dashboard");
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      navigate("/dashboard");
    }
  };

  //Progress Bar component

  function Progressbar() {
    return (
      <div className="flex flex-col items-center">
        <div
          className="relative w-full h-[1.7rem]  rounded-full overflow-hidden"
          style={{
            border: "2px solid rgba(210, 212, 218, 1)",
            backgroundColor: "rgba(241, 244, 251, 1)",
          }}
        >
          <div
            style={{ width: `${progress}%` }}
            className="h-full bg-light-blue transition-width duration-500 rounded-full"
          ></div>
          <span
            className={`absolute inset-0 flex items-center justify-center text-base font-medium ${
              progress <= 43 ? "text-light-blue" : "text-white"
            }`}
          >
            {progress}% {translations.instruction[language].s8}
          </span>
        </div>
      </div>
    );
  }

  console.log(questions);
  console.log(questions.length);

  console.log(interviews.length, "len", stat);


  if (loader) {
    return (
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <InfinitySpin width="200" color="#4899B7"></InfinitySpin>
      </div>
    );
  } else
    return (
      <div className="h-full w-full">
        {stat == "Pending" &&
        jobData.jobstatus != "Closed" &&
        interviews.length < 4 ? (
          <div>
            {visible && (
              <div className="absolute left-1/2 top-1/2 px-4 py-3  rounded-xl space-y-3 bg-white z-60 -translate-x-1/2 backdrop-blur-sm -translate-y-1/2 ">
                <p className="text-xl">Are you sure you want quit now?</p>
                <p>
                  If you quit now, all your answers submitted till now will be
                  lost and you will have to start from the beginning again
                </p>
              </div>
            )}

            {loader8 ? (
              <div className="h-full w-full">
                <img
                  src={logo}
                  className="lg:h-28 h-20 mt-4 mx-auto p-4 pt-0"
                ></img>

                <div className="flex w-full h-full mt-6 items-center  flex-col ">
                  <div className="flex flex-col p-6 items-center font-poppins space-y-5">
                    <div className="grid w-full relative">
                      <img
                        src={idea}
                        className="h-10 text-center mt-4 animate-bounce justify-self-center "
                      ></img>
                      <div className="md:justify-self-end justify-self-center ">
                        {" "}
                        <Toggle
                          language={language}
                          setLanguage={setLanguage}
                          onColor="rgba(20, 142, 255, 1)"
                        />
                      </div>
                    </div>
                    <p className="sm:text-xl  text-center text-lg font-extrabold">
                      {translations.info[language].s1}
                    </p>
                    <p className="font-extrabold text-xl">
                      {" "}
                      {translations.info[language].s2}
                    </p>
                    <p className="sm:text-lg text-base  text-center font-extrabold ">
                      <span className="font-mono hidden lg:block text-6xl">
                        "
                      </span>
                      {qoutes[index]}
                      <span className="font-mono hidden text-6xl">"</span>
                    </p>
                    <ThreeDots
                      width="50"
                      color="#4899B7"
                      className="mx-auto"
                    ></ThreeDots>
                    <p>interviewguru.co</p>
                  </div>
                  <div className="px-4">
                    <Copyright />
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="bg-cover min-h-screen flex flex-col sm:p-5 p-4 md:!pb-0 !pb-20 "
                style={{
                  backgroundImage: `url(${process.env.PUBLIC_URL + "/Bg.png"})`,
                }}
              >
                <div className="md:flex-grow">
                  {ques == 0 && (
                    <div className="relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      ></img>

                      <div className="lg:w-2/3  relative mx-auto font-poppins">
                        <div
                          className="w-full m-auto lg:mx-auto bg-cover  bg-white rounded-xl flex flex-col space-y-3 p-6 shadow-lg"
                          style={{
                            backgroundImage: `url(${
                              process.env.PUBLIC_URL + "/Rectangle6.png"
                            })`,
                          }}
                        >
                          <div className="flex w-full justify-between flex-col mb-1 sm:flex-row items-center ">
                            <div className="w-fit  flex justify-start">
                              <IoMdArrowBack
                                className="w-8 h-8 cursor-pointer"
                                onClick={() => {
                                  setQues(21);
                                }}
                              />
                            </div>
                            <p className=" mx-3 my-2 text-center grow sm:pl-44 pl-0 font-semibold text-2xl">
                              {translations.ques0[language].instructionsTitle}
                            </p>
                            <Toggle
                              language={language}
                              setLanguage={setLanguage}
                              onColor="rgba(20, 142, 255, 1)"
                            />
                          </div>

                          {/* <p className=" mx-3">
                        {translations.ques0[language].instructionsTitle}
                      </p> */}
                          <div className="lg:grid lg:grid-cols-2  grid place-content-center space-y-0   gap-x-6">
                            <div
                              className=" rounded-xl text-sm bg-white  p-6"
                              style={{
                                backgroundImage: `url(${
                                  process.env.PUBLIC_URL + "/Rectangle5.png"
                                })`,
                                backgroundSize: "cover",

                                backgroundPositionX: "85%",
                              }}
                            >
                              <img
                                src={testpic1}
                                className="lg:h-36 h-[8rem] mx-auto my-4"
                              ></img>
                              <p className="font-bold my-4">
                                {
                                  translations.ques0[language]
                                    .recordingInstructionsTitle
                                }
                              </p>
                              <ul className="list-disc ml-6">
                                {translations.ques0[
                                  language
                                ].recordingInstructions.map((instruction) => (
                                  <li key={instruction}>{instruction}</li>
                                ))}
                              </ul>
                            </div>

                            <div
                              style={{
                                backgroundImage: `url(${
                                  process.env.PUBLIC_URL + "/Rectangle5.png"
                                })`,
                                backgroundSize: "cover",

                                backgroundPositionX: "85%",
                              }}
                              className=" rounded-xl bg-white text-sm  p-6"
                            >
                              <img
                                src={testpic2}
                                className="lg:h-36 h-[8rem] mx-auto my-4 "
                              ></img>
                              <p className="font-bold my-4">
                                {
                                  translations.ques0[language]
                                    .testingInstructionsTitle
                                }
                              </p>
                              <ul className="list-disc ml-6">
                                {translations.ques0[
                                  language
                                ].testingInstructions.map((instruction) => (
                                  <li key={instruction}>{instruction}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-6">
                        <div className="flex justify-between w-full">
                          <button
                            className="bg-light-blue text-white max-w-96 w-96 min-w-44 py-3 rounded-xl mx-auto"
                            onClick={() => {
                              setQues(5);
                            }}
                          >
                            {translations.ques0[language].nextButton}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {ques == 1 && (
                    <div className="relative">
                      <div className="relative flex items-center justify-center">
                        {langFlag && (
                          <>
                            {/* Overlay */}
                            <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>

                            {/* Popup */}
                            <div className="fixed top-1/2 w-[21rem] max-w-[80%] sm:w-[24rem] left-1/2 z-50 flex flex-col space-y-3 p-4 rounded-lg transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg">
                              <p className="text-lg">
                                Preferred language for recording answers?
                              </p>
                              <div className="flex space-x-4 mt-2">
                                <label className="flex items-center space-x-2">
                                  <input
                                    type="radio"
                                    name="language"
                                    value="EN"
                                    checked={language == "EN"}
                                    onChange={(e) =>
                                      setLanguage(e.target.value)
                                    }
                                    className="hidden"
                                  />
                                  <span
                                    className={`w-6 h-6 flex items-center justify-center rounded-full border border-gray-400 cursor-pointer ${
                                      language == "EN"
                                        ? "bg-blue-500 text-white"
                                        : "bg-white"
                                    }`}
                                  >
                                    {language == "EN" && (
                                      <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M5 13l4 4L19 7"
                                        ></path>
                                      </svg>
                                    )}
                                  </span>
                                  <span className="text-base ">English</span>
                                </label>
                                <label className="flex items-center space-x-2">
                                  <input
                                    type="radio"
                                    name="language"
                                    value={prefLanguage}
                                    checked={language == prefLanguage}
                                    onChange={(e) =>
                                      setLanguage(e.target.value)
                                    }
                                    className="hidden"
                                  />
                                  <span
                                    className={`w-6 h-6 flex items-center justify-center rounded-full border border-gray-400 cursor-pointer ${
                                      language == `${prefLanguage}`
                                        ? "bg-blue-500 text-white"
                                        : "bg-white"
                                    }`}
                                  >
                                    {language == prefLanguage && (
                                      <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M5 13l4 4L19 7"
                                        ></path>
                                      </svg>
                                    )}
                                  </span>
                                  <span lassName="text-base">
                                    {prefLanguage == "HI" ? "Hindi" : "Malay"}
                                  </span>
                                </label>
                              </div>
                              <button
                                className="bg-[#148EFF] text-white rounded-lg w-full py-2 mt-4"
                                onClick={() => {
                                  setLangFlag(false);
                                  setQues(21);
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      ></img>
                      <div className="lg:w-3/4  relative mx-auto font-poppins">
                        <div
                          className=" rounded-2xl  bg-cover bg-white   py-6 px-6"
                          style={{
                            backgroundImage: `url(${
                              process.env.PUBLIC_URL + "/Rectangle6.png"
                            })`,
                          }}
                        >
                          <p className=" mx-3 my-2 text-center font-semibold lg:text-2xl text-xl">
                            {compName.name}
                          </p>

                          <div className="lg:grid lg:grid-cols-2  mx-0   space-y-4 lg:space-y-0 pt-4 gap-x-6">
                            <div className="bg-white rounded-xl about_company border-2 border-slate-300  h-[25rem] overflow-y-scroll">
                              <p className="text-center font-semibold lg:text-xl text:base border-b-4 pb-2 border-light-blue p-3 ">
                                Who are we:
                              </p>
                              <pre
                                style={{ whiteSpace: "pre-wrap" }}
                                className=" font-poppins my-4 text-xs e p-3"
                              >
                                {compName.about}
                              </pre>
                            </div>
                            <div className="bg-white h-[25rem] border-2 about_company  border-slate-300 overflow-y-scroll rounded-xl ">
                              <p className="text-center font-semibold lg:text-xl text:base border-b-4 pb-2 border-light-blue p-3 ">
                                About the job:
                              </p>
                              <ReactQuill
                                className="p-3 text-sm"
                                value={jobData.jobdescription}
                                readOnly={true}
                                theme="bubble"
                              ></ReactQuill>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=" sm:m-auto w-full !mt-6  fixed bottom-4 md:bottom-0 sm:w-fit md:relative md:left-0  left-1/2 -translate-x-1/2 md:-translate-x-0">
                        <div className="flex justify-between gap-3 px-3  md:mt-0 w-full">
                          <button
                            className="bg-light-blue text-white max-w-96 sm:w-96 w-[90%] min-w-44 py-3 rounded-xl mx-auto"
                            onClick={() => {
                              // setQues(12);
                              {
                                prefLanguage != "EN"
                                  ? setLangFlag(true)
                                  : setQues(21);
                              }
                            }}
                          >
                            Start Now
                          </button>
                          <button
                            onClick={() => {
                              navigate("/thankyou");
                            }}
                            className="bg-light-blue text-white max-w-96 sm:w-96 w-[90%] min-w-44 py-3 rounded-xl mx-auto"
                          >
                            Take interview later
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {ques == 21 && (
                    <div className="relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      />
                      <div className="lg:w-3/4 relative mx-auto font-poppins">
                        <div
                          className="rounded-2xl bg-cover bg-white py-6 px-6"
                          style={{
                            backgroundImage: `url(${
                              process.env.PUBLIC_URL + "/Rectangle6.png"
                            })`,
                          }}
                        >
                          <div className="flex flex-col sm:flex-row w-full  items-center py-2">
                            <div className="   sm:w-fit w-full flex justify-start">
                              <IoMdArrowBack
                                className="w-8 h-8 cursor-pointer"
                                onClick={() => {
                                  setQues(1);
                                }}
                              />
                            </div>
                            <p
                              className={`mx-3  grow text-center pl-1  font-semibold text-2xl ${
                                prefLanguage != "EN" ? "sm:ml-40" : "sm:mr-12"
                              }`}
                            >
                              {translations.ques21[language].title}
                            </p>
                            <Toggle
                              language={language}
                              setLanguage={setLanguage}
                              onColor="rgba(20, 142, 255, 1)"
                            />
                          </div>

                          <div className="lg:grid lg:grid-cols-2 mx-0 space-y-4 lg:space-y-0 pt-4 gap-x-6">
                            <div className="bg-white relative rounded-xl about_company border-2  border-slate-300  h-fit  sm:h-[25rem] ">
                              <p className="text-center font-semibold lg:text-xl text:base border-b-4 pb-2 border-light-blue p-3 ">
                                {translations.ques21[language].videoCheck}
                              </p>
                              <div className="p-6 relative  flex flex-col gap-4  w-full">
                                <div className=" ">
                                  <video
                                    playsInline
                                    ref={recordWebcam.webcamRef}
                                    className="rounded-xl w-[20rem]  m-auto "
                                    autoPlay
                                    muted
                                  />
                                </div>
                                <div className="relative w-full justify-center items-center flex gap-6"></div>
                              </div>
                            </div>
                            <div className="bg-white h-[25rem] border-2 about_company border-slate-300 overflow-y-scroll rounded-xl ">
                              <p className="text-center font-semibold lg:text-xl text:base border-b-4 pb-2 border-light-blue p-3 ">
                                {
                                  translations.ques21[language]
                                    .instructionsTitle
                                }
                              </p>
                              <div className="p-6 flex flex-col">
                                {/* <p className="font-bold text-base">
                {translations.ques21[language].recordingInstructionsTitle}
              </p>
              <ul className="list-disc ml-6 text-sm mb-4">
                {translations.ques21[language].recordingInstructions.map((instruction) => (
                  <li key={instruction}>{instruction}</li>
                ))}
              </ul> */}
                                <p className="font-bold text-base">
                                  {
                                    translations.ques21[language]
                                      .testingInstructionsTitle
                                  }
                                </p>
                                <ul className="list-disc ml-6 text-sm">
                                  {translations.ques21[
                                    language
                                  ].testingInstructions.map((instruction) => (
                                    <li key={instruction}>{instruction}</li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="sm:m-auto w-full !mt-6 fixed bottom-4 md:bottom-0 sm:w-fit md:relative md:left-0  left-1/2 -translate-x-1/2 md:-translate-x-0">
                        <div className="flex justify-between w-full">
                          <button
                            className="bg-light-blue text-white max-w-96 sm:w-96 w-[90%] min-w-44 py-3 rounded-xl mx-auto"
                            onClick={() => {
                              setQues(5);
                              setCounter(15);
                            }}
                          >
                            {translations.ques21[language].nextButton}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {ques == 2 && techQuestions.length > 0 && (
                    <div className="w-full h-full relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      ></img>
                      <div className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover mb-6  rounded-xl  ">
                        {" "}
                        <Progressbar progress={progress} />
                      </div>
                      <div
                        className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover bg-white rounded-xl sm:p-6 p-4"
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL + "/Rectangle6.png"
                          })`,
                        }}
                      >
                        <div>
                          {/* <div className="flex bg-[#39435A] items-center space-x-3 px-3 py-3 rounded-xl">
                        <p className="bg-white rounded-full p-2 px-4 font-bold font-poppins">
                          {7 + i}
                        </p>
                        <p className="text-white font-poppins">
                          {techQuestions[i].Question}
                        </p>
                      </div> */}
                          <div className=" ">
                            <div className="flex justify-between items-center pb-4">
                              <p className=" font-semibold">
                                {translations.instruction[language].s6} {7 + i}
                              </p>
                              <Toggle
                                language={language}
                                setLanguage={setLanguage}
                                onColor="rgba(20, 142, 255, 1)"
                              />
                            </div>

                            <div className="flex sm:items-center px-0 md:px-2 items-start sm:justify-between sm:gap:0 gap-3  flex-col sm:flex-row sm:space-x-8 ">
                              <div className="flex sm:mb-0 mb-3  items-center gap-4 sm:gap-0 sm:space-x-8 w-full  sm:order-1 order-2 ">
                                <div className="relative inline-flex items-center justify-center ">
                                  <img
                                    src={sia_face}
                                    className="h-12 w-12 z-10 rounded-full"
                                    alt="Microphone"
                                  />
                                  <div
                                    id="wave-microphone"
                                    className="wavemicrophone hidden absolute top-0 left-0 w-full h-full  items-center justify-center"
                                  >
                                    <div className="wave w-12 h-12 absolute rounded-full border-8 border-blue-500 animate-wave1"></div>
                                    <div className="wave w-14 h-14 absolute rounded-full border-8 border-blue-400 animate-wave2"></div>
                                    <div className="wave w-16 h-16 absolute rounded-full border-8 border-blue-300 animate-wave3"></div>
                                    <div className="wave w-18 h-18 absolute rounded-full border-8 border-blue-200 animate-wave4"></div>
                                  </div>
                                </div>

                                <div className="bg-[#444D63E5] w-fit max-w-[80%] tri-right border_clip round btm-left-in   relative border-[#444D63] md:text-lg text-base text-white  rounded-br-lg p-3">
                                  <p>
                                    {language == "EN"
                                      ? techQuestions[i].Question
                                      : hindiQuestions[i].Question}
                                  </p>
                                </div>
                              </div>
                              <div className="sm:order-2 order-1">
                                {!isSafari && (
                                  <TextToSpeech
                                    text={techQuestions[i].Question}
                                  ></TextToSpeech>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="mx-auto text-center pt-4 ">
                            <div className="relative lg:w-fit-content mx-auto ">
                              <video
                                playsInline
                                ref={recordWebcam.previewRef}
                                className={
                                  recordWebcam.status != "PREVIEW"
                                    ? "mx-auto  rounded-xl hidden h-[17rem]"
                                    : "mx-auto  rounded-xl h-[17rem]"
                                }
                                autoPlay
                                muted={status}
                                loop
                              />
                              <div className="mx-auto relative w-fit flex justify-center">
                                {recordWebcam.status !== "PREVIEW" && (
                                  <video
                                    playsInline
                                    ref={recordWebcam.webcamRef}
                                    className="  rounded-xl h-[17rem]"
                                    autoPlay
                                    muted
                                  />
                                )}
                                {recordWebcam.status == "OPEN" && (
                                  <div className="absolute rounded-xl w-full h-full top-0 flex justify-center items-center text-white mx-auto left-1/2 -translate-x-1/2 right-0 px-6  bg-black bg-opacity-40">
                                    <div className="flex items-center justify-center">
                                      <p className="text-white lg:text-2xl text-xl font-semibold px-2 py-2 rounded-xl">
                                        {translations.instruction[language].s9}
                                        <br />
                                        <span
                                          className={
                                            counter <= 5 && counter > 0
                                              ? "text-red-500 lg:text-3xl text-2xl"
                                              : "text-white lg:text-3xl text-2xl"
                                          }
                                        >
                                          {counter < 10
                                            ? `0${counter}`
                                            : counter}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>

                              {/* {recordWebcam.status == "RECORDING" && (
                            <p className="absolute top-0 text-white w-full mx-autp left-0 right-0">
                              {translations.instruction[language].s1}
                            </p>
                          )} */}
                            </div>
                            <div className="space-x-3 mt-4 flex flex-col gap-4 items-center justify-center">
                              {recordWebcam.status == "OPEN" && (
                                <button
                                  onClick={recordWebcam.start}
                                  className="bg-light-blue  flex gap-2 font-semibold text-base px-6 py-3 rounded-lg text-white"
                                >
                                  <CiMicrophoneOn className="w-6 h-6" />{" "}
                                  {translations.instruction[language].s2}
                                </button>
                              )}
                              {recordWebcam.status == "RECORDING" && (
                                <button
                                  onClick={stop}
                                  className="bg-light-blue px-6 py-3 rounded-xl text-white"
                                >
                                  {translations.instruction[language].s3}
                                </button>
                              )}
                              {recordWebcam.status == "PREVIEW" && (
                                <div className="lg:space-x-3 flex flex-col space-y-3 lg:block lg:space-y-0">
                                  <button
                                    onClick={() => {
                                      techConnect();
                                    }}
                                    className="bg-light-blue px-6 py-3 rounded-xl text-white"
                                  >
                                    {translations.instruction[language].s5}
                                  </button>
                                </div>
                              )}
                              {recordWebcam.status !== "PREVIEW" && (
                                <button
                                  className="bg-transparent  rounded-xl "
                                  onClick={recordWebcam.open}
                                >
                                  {translations.instruction[language].s4}
                                  {language == "HI" ? (
                                    <span className="text-base font-semibold text-light-blue">
                                      {" "}
                                      यहाँ क्लिक करें
                                    </span>
                                  ) : (
                                    <span className="text-base font-semibold text-light-blue">
                                      {" "}
                                      Click Here
                                    </span>
                                  )}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {ques == 20 && (
                    <div>
                      <img
                        src={logo}
                        className="lg:h-28 m-auto h-20 p-4 mb-4 pt-0 "
                      ></img>
                      <div
                        className="lg:w-2/3 mx-3 lg:mx-auto bg-cover  bg-white rounded-xl flex flex-col space-y-3 py-6 lg:px-6 px-3"
                        // style={{
                        //   backgroundImage: `url(${
                        //     process.env.PUBLIC_URL + "/Rectangle6.png"
                        //   })`,
                        // }}
                      >
                        <div className="flex flex-col sm:flex-row w-full  items-center py-2">
                          <div className="sm:w-fit w-full flex justify-start">
                            <IoMdArrowBack
                              className="w-8 h-8 cursor-pointer"
                              onClick={() => {
                                setQues(1);
                              }}
                            />
                          </div>
                          <p
                            className={`mx-3 my-2 grow text-center pl-1  font-semibold text-2xl ${
                              prefLanguage != "EN" ? "sm:ml-40" : "sm:mr-12"
                            }`}
                          >
                            {translations.ques20[language].title}
                          </p>
                          <Toggle
                            language={language}
                            setLanguage={setLanguage}
                            onColor="rgba(20, 142, 255, 1)"
                          />
                        </div>

                        <p className="font-sans ">
                          {translations.ques20[language].acknowledgement
                            .replace("{name}", name)
                            .replace("{compName.name}", compName.name)}
                        </p>
                        <p>{translations.ques20[language].consent}</p>
                        <p>{translations.ques20[language].employerUse}</p>
                        <div className="flex space-x-2 items-center  ">
                          <input
                            type="checkbox"
                            checked={checked}
                            className="w-4 h-4"
                            onChange={(e) => {
                              setChecked(e.target.checked);
                            }}
                          ></input>
                          <p>{translations.ques20[language].terms}</p>
                        </div>
                      </div>

                      {/* <div className="fixed bottom-4 left-1/2 -translate-x-1/2 w-full lg:w-3/4 px-3 mx-auto"> */}

                      <div className="sm:m-auto w-full !mt-6 fixed bottom-4 md:bottom-0 sm:w-fit md:relative md:left-0  left-1/2 -translate-x-1/2 md:-translate-x-0">
                        <div className="flex justify-between w-full">
                          <button
                            disabled={!checked}
                            className={
                              checked
                                ? "bg-light-blue text-white max-w-96 sm:w-96 w-[90%] min-w-44 py-3 rounded-xl mx-auto"
                                : "bg-gray-400 text-white max-w-96 sm:w-96 w-[90%] min-w-44 py-3 rounded-xl mx-auto"
                            }
                            onClick={() => {
                              setQues(21);
                            }}
                          >
                            {translations.ques20[language].nextButton}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {ques == 4 && (
                    <div
                      className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover bg-white rounded-xl py-4 px-3"
                      style={{
                        backgroundImage: `url(${
                          process.env.PUBLIC_URL + "/Rectangle6.png"
                        })`,
                      }}
                    >
                      {/* <div className="flex bg-[#39435A] items-center space-x-3 px-3 py-3 rounded-xl">
                      <p className="bg-white rounded-full p-2 px-4 font-bold font-poppins">
                        1
                      </p>
                      <p className="text-white font-poppins">
                        {s[0].statement}
                      </p>
                    </div> */}
                      <div>
                        <p>{translations.instruction[language].s6} 1</p>
                        <></>
                      </div>
                      <div className="mx-auto text-center relative py-3 ">
                        <div className="relative lg:w-1/2  mx-auto">
                          <video
                            playsInline
                            ref={recordWebcam.previewRef}
                            className={
                              recordWebcam.status != "PREVIEW"
                                ? "mx-auto my-4 rounded-xl hidden"
                                : "mx-auto my-4 rounded-xl"
                            }
                            autoPlay
                            muted={status}
                            loop
                          />
                          {recordWebcam.status !== "PREVIEW" && (
                            <video
                              playsInline
                              ref={recordWebcam.webcamRef}
                              className="mx-auto my-4 rounded-xl "
                              autoPlay
                              muted
                            />
                          )}
                          {recordWebcam.status == "OPEN" && (
                            <div className=" absolute top-0 text-white w-full mx-autp left-1/2 -translate-x-1/2 right-0 p-4">
                              <div className="flex items-center justify-center">
                                <TbPlayerRecordFilled className="text-red-500 animate-pulse"></TbPlayerRecordFilled>
                                <p className="bg-white text-red-500 px-2 py-2 rounded-xl">{`00:$<span className={counter <= 5 && counter > 0 ? "text-red-500" : "text-white"}>
          {counter}
        </span>`}</p>
                              </div>
                            </div>
                          )}
                          {recordWebcam.status == "RECORDING" && (
                            <p className="absolute top-0 text-white w-full mx-autp left-0 right-0">
                              <p>{translations.instruction[language].s1}</p>
                            </p>
                          )}
                        </div>
                        <div className="space-x-3">
                          {recordWebcam.status == "OPEN" && (
                            <button
                              onClick={recordWebcam.start}
                              className="bg-green-500 px-6 py-3 rounded-xl text-white"
                            >
                              {translations.instruction[language].s2}
                            </button>
                          )}
                          {recordWebcam.status == "RECORDING" && (
                            <button
                              onClick={stop}
                              className="bg-light-blue px-6 py-3 rounded-xl text-white"
                            >
                              {translations.instruction[language].s3}
                            </button>
                          )}
                          {recordWebcam.status == "PREVIEW" && (
                            <div className="lg:space-x-3 flex flex-col space-y-3 lg:block lg:space-y-0">
                              <button
                                onClick={() => {
                                  setLoader1(true);
                                  saveFile1();
                                  setCounter(15);
                                }}
                                className="bg-light-blue px-6 py-3 rounded-xl text-white"
                              >
                                {translations.instruction[language].s5}
                              </button>
                            </div>
                          )}
                          <button
                            className="bg-transparent px-6 py-3 rounded-xl "
                            onClick={recordWebcam.open}
                          >
                            {translations.instruction[language].s4}
                          </button>
                        </div>
                      </div>
                      {
                        // recordWebcam.status == "PREVIEW" &&
                      }
                    </div>
                  )}

                  {ques == 5 && (
                    <div className="w-full h-full relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      ></img>
                      <div className="lg:w-2/3  sm:w-[85%]  w-full mx-auto   bg-cover mb-6  rounded-xl  ">
                        <Progressbar progress={progress} />
                      </div>
                      <div
                        className={
                          !langFlag
                            ? "lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover bg-white  rounded-xl sm:p-6 p-4"
                            : "lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover blur-xl bg-white  rounded-xl py-4 px-6"
                        }
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL + "/Rectangle6.png"
                          })`,
                        }}
                      >
                        <div className="">
                          <div className="flex justify-between items-center pb-4">
                            <p className=" font-semibold">
                              {translations.instruction[language].s6} 1
                            </p>
                            <Toggle
                              language={language}
                              setLanguage={setLanguage}
                              onColor="rgba(20, 142, 255, 1)"
                            />
                          </div>
                          <div className="flex sm:items-center px-0 md:px-2 items-start sm:justify-between sm:gap:0 gap-3  flex-col sm:flex-row sm:space-x-8 ">
                            <div className="flex sm:mb-0 mb-3  items-center gap-4 sm:gap-0 sm:space-x-8 w-full  sm:order-1 order-2 ">
                              <div className="relative inline-flex items-center justify-center ">
                                <img
                                  src={sia_face}
                                  className="h-12 w-12 z-10 rounded-full"
                                  alt="Microphone"
                                />
                                <div
                                  id="wave-microphone"
                                  className="wavemicrophone hidden absolute top-0 left-0 w-full h-full  items-center justify-center"
                                >
                                  <div className="wave w-12 h-12 absolute rounded-full border-8 border-blue-500 animate-wave1"></div>
                                  <div className="wave w-14 h-14 absolute rounded-full border-8 border-blue-400 animate-wave2"></div>
                                  <div className="wave w-16 h-16 absolute rounded-full border-8 border-blue-300 animate-wave3"></div>
                                  <div className="wave w-18 h-18 absolute rounded-full border-8 border-blue-200 animate-wave4"></div>
                                </div>
                              </div>

                              <div className="bg-[#444D63E5] w-fit max-w-[80%] tri-right border_clip round btm-left-in   relative border-[#444D63] md:text-lg text-base text-white  rounded-br-lg p-3">
                                <p>
                                  {language == "HI"
                                    ? questions[1].hindistatement
                                    : questions[1].statement}
                                </p>
                              </div>
                            </div>
                            <div className="sm:order-2 order-1">
                              {!isSafari && (
                                <TextToSpeech
                                  text={questions[1].statement}
                                ></TextToSpeech>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="mx-auto text-center pt-4 ">
                          <div className="relative lg:w-fit-content mx-auto ">
                            <video
                              playsInline
                              ref={recordWebcam.previewRef}
                              className={
                                recordWebcam.status != "PREVIEW"
                                  ? "mx-auto  rounded-xl hidden h-[17rem]"
                                  : "mx-auto  rounded-xl h-[17rem]"
                              }
                              autoPlay
                              muted={status}
                              loop
                            />
                            <div className="mx-auto relative w-fit flex justify-center">
                              {recordWebcam.status !== "PREVIEW" && (
                                <video
                                  playsInline
                                  ref={recordWebcam.webcamRef}
                                  className="  rounded-xl sm:h-[17rem] "
                                  autoPlay
                                  muted
                                />
                              )}
                              {recordWebcam.status == "OPEN" && (
                                <div className="absolute rounded-xl w-full h-full top-0 flex justify-center items-center text-white mx-auto left-1/2 -translate-x-1/2 right-0 px-6  bg-black bg-opacity-40">
                                  <div className="flex items-center justify-center">
                                    <p className="text-white lg:text-2xl text-xl font-semibold px-2 py-2 rounded-xl">
                                      {translations.instruction[language].s9}
                                      <br />
                                      <span
                                        className={
                                          counter <= 5 && counter > 0
                                            ? "text-red-500 lg:text-3xl text-2xl"
                                            : "text-white lg:text-3xl text-2xl"
                                        }
                                      >
                                        {counter < 10 ? `0${counter}` : counter}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* {recordWebcam.status == "RECORDING" && (
                            <p className="absolute top-0 text-white w-full mx-autp left-0 right-0">
                              {translations.instruction[language].s1}
                            </p>
                          )} */}
                          </div>
                          <div className="space-x-3 mt-4 flex flex-col gap-4 items-center  justify-center">
                            {recordWebcam.status == "OPEN" && (
                              <button
                                onClick={recordWebcam.start}
                                className="bg-light-blue  flex gap-2 font-semibold text-base px-6 py-3 rounded-lg text-white"
                              >
                                <CiMicrophoneOn className="w-6 h-6" />{" "}
                                {translations.instruction[language].s2}
                              </button>
                            )}
                            {recordWebcam.status == "RECORDING" && (
                              <button
                                onClick={stop}
                                className="bg-light-blue px-6 py-3 rounded-xl text-white"
                              >
                                {translations.instruction[language].s3}
                              </button>
                            )}
                            {recordWebcam.status == "PREVIEW" && (
                              <div className="lg:space-x-3 flex flex-col space-y-3 lg:block lg:space-y-0">
                                <button
                                  onClick={() => {
                                    setLoader2(true);
                                    saveFile2();
                                    setCounter(15);
                                    handleStepsProgress();
                                  }}
                                  className="bg-light-blue px-6 py-3 rounded-xl text-white"
                                >
                                  {translations.instruction[language].s5}
                                </button>
                              </div>
                            )}
                            {recordWebcam.status !== "PREVIEW" && (
                              <button
                                className="bg-transparent  rounded-xl "
                                onClick={recordWebcam.open}
                              >
                                {translations.instruction[language].s4}
                                {language == "HI" ? (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    यहाँ क्लिक करें
                                  </span>
                                ) : (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    Click Here
                                  </span>
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                        {
                          // recordWebcam.status == "PREVIEW" &&
                        }
                      </div>
                    </div>
                  )}
                  {ques == 6 && (
                    <div className="w-full h-full relative">
                      <img
                        src={logo}
                        className="lg:h-28  h-20 m-auto p-4 mb-4 pt-0"
                      ></img>
                      <div className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover mb-6  rounded-xl  ">
                        {" "}
                        <Progressbar progress={progress} />
                      </div>
                      <div
                        className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover bg-white rounded-xl p-6"
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL + "/Rectangle6.png"
                          })`,
                        }}
                      >
                        {/* <div className="flex bg-[#39435A] items-center space-x-3 px-3 py-3 rounded-xl">
                      <p className="bg-white rounded-full p-2 px-4 font-bold font-poppins">
                        2
                      </p>
                      <p className="text-white font-poppins">
                        {questions[2].statement}
                      </p>
                    </div> */}
                        <div className="">
                          <div className="flex justify-between items-center pb-4">
                            <p className=" font-semibold">
                              {translations.instruction[language].s6} 2
                            </p>
                            <Toggle
                              language={language}
                              setLanguage={setLanguage}
                              onColor="rgba(20, 142, 255, 1)"
                            />
                          </div>
                          <div className="flex sm:items-center px-0 md:px-2 items-start sm:justify-between sm:gap:0 gap-3  flex-col sm:flex-row sm:space-x-8 ">
                            <div className="flex sm:mb-0 mb-3  items-center gap-4 sm:gap-0 sm:space-x-8 w-full  sm:order-1 order-2 ">
                              <div className="relative inline-flex items-center justify-center ">
                                <img
                                  src={sia_face}
                                  className="h-12 w-12 z-10 rounded-full"
                                  alt="Microphone"
                                />
                                <div
                                  id="wave-microphone"
                                  className="wavemicrophone hidden absolute top-0 left-0 w-full h-full  items-center justify-center"
                                >
                                  <div className="wave w-12 h-12 absolute rounded-full border-8 border-blue-500 animate-wave1"></div>
                                  <div className="wave w-14 h-14 absolute rounded-full border-8 border-blue-400 animate-wave2"></div>
                                  <div className="wave w-16 h-16 absolute rounded-full border-8 border-blue-300 animate-wave3"></div>
                                  <div className="wave w-18 h-18 absolute rounded-full border-8 border-blue-200 animate-wave4"></div>
                                </div>
                              </div>

                              <div className="bg-[#444D63E5] w-fit max-w-[80%] tri-right border_clip round btm-left-in   relative border-[#444D63] md:text-lg text-base text-white  rounded-br-lg p-3">
                                <p>
                                  {language == "HI"
                                    ? questions[2].hindistatement
                                    : questions[2].statement}
                                </p>
                              </div>
                            </div>
                            <div className="sm:order-2 order-1">
                              {!isSafari && (
                                <TextToSpeech
                                  text={questions[2].statement}
                                ></TextToSpeech>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="mx-auto text-center pt-4 ">
                          <div className="relative lg:w-fit-content mx-auto ">
                            <video
                              playsInline
                              ref={recordWebcam.previewRef}
                              className={
                                recordWebcam.status != "PREVIEW"
                                  ? "mx-auto  rounded-xl hidden h-[17rem]"
                                  : "mx-auto  rounded-xl h-[17rem]"
                              }
                              autoPlay
                              muted={status}
                              loop
                            />
                            <div className="mx-auto relative w-fit flex justify-center">
                              {recordWebcam.status !== "PREVIEW" && (
                                <video
                                  playsInline
                                  ref={recordWebcam.webcamRef}
                                  className="  rounded-xl h-[17rem]"
                                  autoPlay
                                  muted
                                />
                              )}
                              {recordWebcam.status == "OPEN" && (
                                <div className="absolute rounded-xl w-full h-full top-0 flex justify-center items-center text-white mx-auto left-1/2 -translate-x-1/2 right-0 px-6  bg-black bg-opacity-40">
                                  <div className="flex items-center justify-center">
                                    <p className="text-white lg:text-2xl text-xl font-semibold  py-2 rounded-xl">
                                      {translations.instruction[language].s9}
                                      <br />
                                      <span
                                        className={
                                          counter <= 5 && counter > 0
                                            ? "text-red-500 lg:text-3xl text-2xl"
                                            : "text-white lg:text-3xl text-2xl"
                                        }
                                      >
                                        {counter < 10 ? `0${counter}` : counter}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* {recordWebcam.status == "RECORDING" && (
                            <p className="absolute top-0 text-white w-full mx-autp left-0 right-0">
                              {translations.instruction[language].s1}
                            </p>
                          )} */}
                          </div>
                          <div className="space-x-3 mt-4 flex flex-col gap-4 items-center justify-center">
                            {recordWebcam.status == "OPEN" && (
                              <button
                                onClick={recordWebcam.start}
                                className="bg-light-blue  flex gap-2 font-semibold text-base px-6 py-3 rounded-lg text-white"
                              >
                                <CiMicrophoneOn className="w-6 h-6" />{" "}
                                {translations.instruction[language].s2}
                              </button>
                            )}
                            {recordWebcam.status == "RECORDING" && (
                              <button
                                onClick={stop}
                                className="bg-light-blue px-6 py-3 rounded-xl text-white"
                              >
                                {translations.instruction[language].s3}
                              </button>
                            )}
                            {recordWebcam.status == "PREVIEW" && (
                              <div className="lg:space-x-3 flex flex-col space-y-3 lg:block lg:space-y-0">
                                <button
                                  onClick={() => {
                                    setLoader3(true);
                                    saveFile3();
                                    setCounter(15);
                                    handleStepsProgress();
                                  }}
                                  className="bg-light-blue px-6 py-3 rounded-xl text-white"
                                >
                                  {translations.instruction[language].s5}
                                </button>
                              </div>
                            )}
                            {recordWebcam.status !== "PREVIEW" && (
                              <button
                                className="bg-transparent  rounded-xl "
                                onClick={recordWebcam.open}
                              >
                                {translations.instruction[language].s4}
                                {language == "HI" ? (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    यहाँ क्लिक करें
                                  </span>
                                ) : (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    Click Here
                                  </span>
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                        {
                          // recordWebcam.status == "PREVIEW" &&
                        }
                      </div>
                    </div>
                  )}
                  {ques == 7 && (
                    <div className="w-full h-full relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      ></img>
                      <div className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover mb-6  rounded-xl  ">
                        {" "}
                        <Progressbar progress={progress} />
                      </div>
                      <div
                        className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover bg-white rounded-xl p-6"
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL + "/Rectangle6.png"
                          })`,
                        }}
                      >
                        {/* <div className="flex bg-[#39435A] items-center space-x-3 px-3 py-3 rounded-xl">
                      <p className="bg-white rounded-full p-2 px-4 font-bold font-poppins">
                        3
                      </p>
                      <p className="text-white font-poppins">
                        {questions[3].statement}
                      </p>
                    </div> */}
                        <div className="">
                          <div className="flex justify-between items-center pb-4">
                            <p className=" font-semibold">
                              {translations.instruction[language].s6} 3
                            </p>
                            <Toggle
                              language={language}
                              setLanguage={setLanguage}
                              onColor="rgba(20, 142, 255, 1)"
                            />
                          </div>
                          <div className="flex sm:items-center px-0 md:px-2 items-start sm:justify-between sm:gap:0 gap-3  flex-col sm:flex-row sm:space-x-8 ">
                            <div className="flex sm:mb-0 mb-3  items-center gap-4 sm:gap-0 sm:space-x-8 w-full  sm:order-1 order-2 ">
                              <div className="relative inline-flex items-center justify-center ">
                                <img
                                  src={sia_face}
                                  className="h-12 w-12 z-10 rounded-full"
                                  alt="Microphone"
                                />
                                <div
                                  id="wave-microphone"
                                  className="wavemicrophone hidden absolute top-0 left-0 w-full h-full  items-center justify-center"
                                >
                                  <div className="wave w-12 h-12 absolute rounded-full border-8 border-blue-500 animate-wave1"></div>
                                  <div className="wave w-14 h-14 absolute rounded-full border-8 border-blue-400 animate-wave2"></div>
                                  <div className="wave w-16 h-16 absolute rounded-full border-8 border-blue-300 animate-wave3"></div>
                                  <div className="wave w-18 h-18 absolute rounded-full border-8 border-blue-200 animate-wave4"></div>
                                </div>
                              </div>

                              <div className="bg-[#444D63E5] w-fit max-w-[80%] tri-right border_clip round btm-left-in   relative border-[#444D63] md:text-lg text-base text-white  rounded-br-lg p-3">
                                <p>
                                  {language == "HI"
                                    ? questions[3].hindistatement
                                    : questions[3].statement}
                                </p>
                              </div>
                            </div>
                            <div className="sm:order-2 order-1">
                              {!isSafari && (
                                <TextToSpeech
                                  text={questions[3].statement}
                                ></TextToSpeech>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="mx-auto text-center pt-4 ">
                          <div className="relative lg:w-fit-content mx-auto ">
                            <video
                              playsInline
                              ref={recordWebcam.previewRef}
                              className={
                                recordWebcam.status != "PREVIEW"
                                  ? "mx-auto  rounded-xl hidden h-[17rem]"
                                  : "mx-auto  rounded-xl h-[17rem]"
                              }
                              autoPlay
                              muted={status}
                              loop
                            />
                            <div className="mx-auto relative w-fit flex justify-center">
                              {recordWebcam.status !== "PREVIEW" && (
                                <video
                                  playsInline
                                  ref={recordWebcam.webcamRef}
                                  className="  rounded-xl h-[17rem]"
                                  autoPlay
                                  muted
                                />
                              )}
                              {recordWebcam.status == "OPEN" && (
                                <div className="absolute rounded-xl w-full h-full top-0 flex justify-center items-center text-white mx-auto left-1/2 -translate-x-1/2 right-0 px-6  bg-black bg-opacity-40">
                                  <div className="flex items-center justify-center">
                                    <p className="text-white lg:text-2xl text-xl font-semibold px-2 py-2 rounded-xl">
                                      {translations.instruction[language].s9}
                                      <br />
                                      <span
                                        className={
                                          counter <= 5 && counter > 0
                                            ? "text-red-500 lg:text-3xl text-2xl"
                                            : "text-white lg:text-3xl text-2xl"
                                        }
                                      >
                                        {counter < 10 ? `0${counter}` : counter}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* {recordWebcam.status == "RECORDING" && (
                            <p className="absolute top-0 text-white w-full mx-autp left-0 right-0">
                              {translations.instruction[language].s1}
                            </p>
                          )} */}
                          </div>
                          <div className="space-x-3 mt-4 flex flex-col gap-4 items-center justify-center">
                            {recordWebcam.status == "OPEN" && (
                              <button
                                onClick={recordWebcam.start}
                                className="bg-light-blue  flex gap-2 font-semibold text-base px-6 py-3 rounded-lg text-white"
                              >
                                <CiMicrophoneOn className="w-6 h-6" />{" "}
                                {translations.instruction[language].s2}
                              </button>
                            )}
                            {recordWebcam.status == "RECORDING" && (
                              <button
                                onClick={stop}
                                className="bg-light-blue px-6 py-3 rounded-xl text-white"
                              >
                                {translations.instruction[language].s3}
                              </button>
                            )}
                            {recordWebcam.status == "PREVIEW" && (
                              <div className="lg:space-x-3 flex flex-col space-y-3 lg:block lg:space-y-0">
                                <button
                                  onClick={() => {
                                    setLoader4(true);
                                    saveFile4();
                                    setCounter(15);
                                    handleStepsProgress();
                                  }}
                                  className="bg-light-blue px-6 py-3 rounded-xl text-white"
                                >
                                  {translations.instruction[language].s5}
                                </button>
                              </div>
                            )}
                            {recordWebcam.status !== "PREVIEW" && (
                              <button
                                className="bg-transparent  rounded-xl "
                                onClick={recordWebcam.open}
                              >
                                {translations.instruction[language].s4}
                                {language == "HI" ? (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    यहाँ क्लिक करें
                                  </span>
                                ) : (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    Click Here
                                  </span>
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {ques == 8 && (
                    <div className="w-full h-full relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      ></img>
                      <div className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover mb-6  rounded-xl  ">
                        {" "}
                        <Progressbar progress={progress} />
                      </div>
                      <div
                        className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover bg-white rounded-xl p-6"
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL + "/Rectangle6.png"
                          })`,
                        }}
                      >
                        {/* <div className="flex bg-[#39435A] items-center space-x-3 px-3 py-3 rounded-xl">
                      <p className="bg-white rounded-full p-2 px-4 font-bold font-poppins">
                        4
                      </p>
                      <p className="text-white font-poppins">
                        {questions[4].statement}
                      </p>
                    </div> */}
                        <div className="">
                          <div className="flex justify-between items-center pb-4">
                            <p className=" font-semibold">
                              {translations.instruction[language].s6} 4
                            </p>
                            <Toggle
                              language={language}
                              setLanguage={setLanguage}
                              onColor="rgba(20, 142, 255, 1)"
                            />
                          </div>
                          <div className="flex sm:items-center px-0 md:px-2 items-start sm:justify-between sm:gap:0 gap-3  flex-col sm:flex-row sm:space-x-8 ">
                            <div className="flex sm:mb-0 mb-3  items-center gap-4 sm:gap-0 sm:space-x-8 w-full  sm:order-1 order-2 ">
                              <div className="relative inline-flex items-center justify-center ">
                                <img
                                  src={sia_face}
                                  className="h-12 w-12 z-10 rounded-full"
                                  alt="Microphone"
                                />
                                <div
                                  id="wave-microphone"
                                  className="wavemicrophone hidden absolute top-0 left-0 w-full h-full  items-center justify-center"
                                >
                                  <div className="wave w-12 h-12 absolute rounded-full border-8 border-blue-500 animate-wave1"></div>
                                  <div className="wave w-14 h-14 absolute rounded-full border-8 border-blue-400 animate-wave2"></div>
                                  <div className="wave w-16 h-16 absolute rounded-full border-8 border-blue-300 animate-wave3"></div>
                                  <div className="wave w-18 h-18 absolute rounded-full border-8 border-blue-200 animate-wave4"></div>
                                </div>
                              </div>

                              <div className="bg-[#444D63E5] w-fit max-w-[80%] tri-right border_clip round btm-left-in   relative border-[#444D63] md:text-lg text-base text-white  rounded-br-lg p-3">
                                <p>
                                  {language == "HI"
                                    ? questions[4].hindistatement
                                    : questions[4].statement}
                                </p>
                              </div>
                            </div>
                            <div className="sm:order-2 order-1">
                              {!isSafari && (
                                <TextToSpeech
                                  text={questions[4].statement}
                                ></TextToSpeech>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="mx-auto text-center pt-4 ">
                          <div className="relative lg:w-fit-content mx-auto ">
                            <video
                              playsInline
                              ref={recordWebcam.previewRef}
                              className={
                                recordWebcam.status != "PREVIEW"
                                  ? "mx-auto  rounded-xl hidden h-[17rem]"
                                  : "mx-auto  rounded-xl h-[17rem]"
                              }
                              autoPlay
                              muted={status}
                              loop
                            />
                            <div className="mx-auto relative w-fit flex justify-center">
                              {recordWebcam.status !== "PREVIEW" && (
                                <video
                                  playsInline
                                  ref={recordWebcam.webcamRef}
                                  className="  rounded-xl h-[17rem]"
                                  autoPlay
                                  muted
                                />
                              )}
                              {recordWebcam.status == "OPEN" && (
                                <div className="absolute rounded-xl w-full h-full top-0 flex justify-center items-center text-white mx-auto left-1/2 -translate-x-1/2 right-0 px-6  bg-black bg-opacity-40">
                                  <div className="flex items-center justify-center">
                                    <p className="text-white lg:text-2xl text-xl font-semibold px-2 py-2 rounded-xl">
                                      {translations.instruction[language].s9}
                                      <br />
                                      <span
                                        className={
                                          counter <= 5 && counter > 0
                                            ? "text-red-500 lg:text-3xl text-2xl"
                                            : "text-white lg:text-3xl text-2xl"
                                        }
                                      >
                                        {counter < 10 ? `0${counter}` : counter}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* {recordWebcam.status == "RECORDING" && (
                            <p className="absolute top-0 text-white w-full mx-autp left-0 right-0">
                              {translations.instruction[language].s1}
                            </p>
                          )} */}
                          </div>
                          <div className="space-x-3 mt-4 flex flex-col gap-4 items-center justify-center">
                            {recordWebcam.status == "OPEN" && (
                              <button
                                onClick={recordWebcam.start}
                                className="bg-light-blue  flex gap-2 font-semibold text-base px-6 py-3 rounded-lg text-white"
                              >
                                <CiMicrophoneOn className="w-6 h-6" />{" "}
                                {translations.instruction[language].s2}
                              </button>
                            )}
                            {recordWebcam.status == "RECORDING" && (
                              <button
                                onClick={stop}
                                className="bg-light-blue px-6 py-3 rounded-xl text-white"
                              >
                                {translations.instruction[language].s3}
                              </button>
                            )}
                            {recordWebcam.status == "PREVIEW" && (
                              <div className="lg:space-x-3 flex flex-col space-y-3 lg:block lg:space-y-0">
                                <button
                                  onClick={() => {
                                    setLoader5(true);
                                    saveFile5();
                                    setCounter(15);
                                    handleStepsProgress();
                                  }}
                                  className="bg-light-blue px-6 py-3 rounded-xl text-white"
                                >
                                  {translations.instruction[language].s5}
                                </button>
                              </div>
                            )}
                            {recordWebcam.status !== "PREVIEW" && (
                              <button
                                className="bg-transparent  rounded-xl "
                                onClick={recordWebcam.open}
                              >
                                {translations.instruction[language].s4}
                                {language == "HI" ? (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    यहाँ क्लिक करें
                                  </span>
                                ) : (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    Click Here
                                  </span>
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {ques == 9 && (
                    <div className="w-full h-full relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      ></img>
                      <div className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover mb-6  rounded-xl  ">
                        {" "}
                        <Progressbar progress={progress} />
                      </div>
                      <div
                        className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover bg-white rounded-xl p-6"
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL + "/Rectangle6.png"
                          })`,
                        }}
                      >
                        {/* <div className="flex bg-[#39435A] items-center space-x-3 px-3 py-3 rounded-xl">
                      <p className="bg-white rounded-full p-2 px-4 font-bold font-poppins">
                        5
                      </p>
                      <p className="text-white font-poppins">
                        {questions[5].statement}
                      </p>
                    </div> */}
                        <div className="">
                          <div className="flex justify-between items-center pb-4">
                            <p className=" font-semibold">
                              {translations.instruction[language].s6} 5
                            </p>
                            <Toggle
                              language={language}
                              setLanguage={setLanguage}
                              onColor="rgba(20, 142, 255, 1)"
                            />
                          </div>
                          <div className="flex sm:items-center px-0 md:px-2 items-start sm:justify-between sm:gap:0 gap-3  flex-col sm:flex-row sm:space-x-8 ">
                            <div className="flex sm:mb-0 mb-3  items-center gap-4 sm:gap-0 sm:space-x-8 w-full  sm:order-1 order-2 ">
                              <div className="relative inline-flex items-center justify-center ">
                                <img
                                  src={sia_face}
                                  className="h-12 w-12 z-10 rounded-full"
                                  alt="Microphone"
                                />
                                <div
                                  id="wave-microphone"
                                  className="wavemicrophone hidden absolute top-0 left-0 w-full h-full  items-center justify-center"
                                >
                                  <div className="wave w-12 h-12 absolute rounded-full border-8 border-blue-500 animate-wave1"></div>
                                  <div className="wave w-14 h-14 absolute rounded-full border-8 border-blue-400 animate-wave2"></div>
                                  <div className="wave w-16 h-16 absolute rounded-full border-8 border-blue-300 animate-wave3"></div>
                                  <div className="wave w-18 h-18 absolute rounded-full border-8 border-blue-200 animate-wave4"></div>
                                </div>
                              </div>

                              <div className="bg-[#444D63E5] w-fit max-w-[80%] tri-right border_clip round btm-left-in   relative border-[#444D63] md:text-lg text-base text-white  rounded-br-lg p-3">
                                <p>
                                  {language == "HI"
                                    ? questions[5].hindistatement
                                    : questions[5].statement}
                                </p>
                              </div>
                            </div>
                            <div className="sm:order-2 order-1">
                              {!isSafari && (
                                <TextToSpeech
                                  text={questions[5].statement}
                                ></TextToSpeech>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="mx-auto text-center pt-4 ">
                          <div className="relative lg:w-fit-content mx-auto ">
                            <video
                              playsInline
                              ref={recordWebcam.previewRef}
                              className={
                                recordWebcam.status != "PREVIEW"
                                  ? "mx-auto  rounded-xl hidden h-[17rem]"
                                  : "mx-auto  rounded-xl h-[17rem]"
                              }
                              autoPlay
                              muted={status}
                              loop
                            />
                            <div className="mx-auto relative w-fit flex justify-center">
                              {recordWebcam.status !== "PREVIEW" && (
                                <video
                                  playsInline
                                  ref={recordWebcam.webcamRef}
                                  className="  rounded-xl h-[17rem]"
                                  autoPlay
                                  muted
                                />
                              )}
                              {recordWebcam.status == "OPEN" && (
                                <div className="absolute rounded-xl w-full h-full top-0 flex justify-center items-center text-white mx-auto left-1/2 -translate-x-1/2 right-0 px-6  bg-black bg-opacity-40">
                                  <div className="flex items-center justify-center">
                                    <p className="text-white lg:text-2xl text-xl font-semibold px-2 py-2 rounded-xl">
                                      {translations.instruction[language].s9}
                                      <br />
                                      <span
                                        className={
                                          counter <= 5 && counter > 0
                                            ? "text-red-500 lg:text-3xl text-2xl"
                                            : "text-white lg:text-3xl text-2xl"
                                        }
                                      >
                                        {counter < 10 ? `0${counter}` : counter}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* {recordWebcam.status == "RECORDING" && (
                            <p className="absolute top-0 text-white w-full mx-autp left-0 right-0">
                              {translations.instruction[language].s1}
                            </p>
                          )} */}
                          </div>
                          <div className="space-x-3 mt-4 flex flex-col gap-4 items-center justify-center">
                            {recordWebcam.status == "OPEN" && (
                              <button
                                onClick={recordWebcam.start}
                                className="bg-light-blue  flex gap-2 font-semibold text-base px-6 py-3 rounded-lg text-white"
                              >
                                <CiMicrophoneOn className="w-6 h-6" />{" "}
                                {translations.instruction[language].s2}
                              </button>
                            )}
                            {recordWebcam.status == "RECORDING" && (
                              <button
                                onClick={stop}
                                className="bg-light-blue px-6 py-3 rounded-xl text-white"
                              >
                                {translations.instruction[language].s3}
                              </button>
                            )}
                            {recordWebcam.status == "PREVIEW" && (
                              <div className="lg:space-x-3 flex flex-col space-y-3 lg:block lg:space-y-0">
                                <button
                                  onClick={() => {
                                    setLoader6(true);
                                    saveFile6();
                                    setCounter(15);
                                    handleStepsProgress();
                                  }}
                                  className="bg-light-blue px-6 py-3 rounded-xl text-white"
                                >
                                  {translations.instruction[language].s5}
                                </button>
                              </div>
                            )}
                            {recordWebcam.status !== "PREVIEW" && (
                              <button
                                className="bg-transparent  rounded-xl "
                                onClick={recordWebcam.open}
                              >
                                {translations.instruction[language].s4}
                                {language == "HI" ? (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    यहाँ क्लिक करें
                                  </span>
                                ) : (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    Click Here
                                  </span>
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {ques == 10 && (
                    <div className="w-full h-full relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      ></img>
                      <div className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover mb-6  rounded-xl  ">
                        {" "}
                        <Progressbar progress={progress} />
                      </div>
                      <div
                        className="lg:w-2/3 mx-3 lg:mx-auto rounded-xl bg-white bg-cover p-6"
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL + "/Rectangle6.png"
                          })`,
                        }}
                      >
                        {/* <div className="flex bg-[#39435A] items-center space-x-3 px-3 py-3 rounded-xl">
                      <p className="bg-white rounded-full p-2 px-4 font-bold font-poppins">
                        6
                      </p>
                      <p className="text-white font-poppins">
                        {questions[6].statement}
                      </p>
                    </div> */}
                        <div className="">
                          <div className="flex justify-between items-center pb-4">
                            <p className=" font-semibold">
                              {translations.instruction[language].s6} 6
                            </p>
                            <Toggle
                              language={language}
                              setLanguage={setLanguage}
                              onColor="rgba(20, 142, 255, 1)"
                            />
                          </div>
                          <div className="flex sm:items-center px-0 md:px-2 items-start sm:justify-between sm:gap:0 gap-3  flex-col sm:flex-row sm:space-x-8 ">
                            <div className="flex sm:mb-0 mb-3  items-center gap-4 sm:gap-0 sm:space-x-8 w-full  sm:order-1 order-2 ">
                              <div className="relative inline-flex items-center justify-center ">
                                <img
                                  src={sia_face}
                                  className="h-12 w-12 z-10 rounded-full"
                                  alt="Microphone"
                                />
                                <div
                                  id="wave-microphone"
                                  className="wavemicrophone hidden absolute top-0 left-0 w-full h-full  items-center justify-center"
                                >
                                  <div className="wave w-12 h-12 absolute rounded-full border-8 border-blue-500 animate-wave1"></div>
                                  <div className="wave w-14 h-14 absolute rounded-full border-8 border-blue-400 animate-wave2"></div>
                                  <div className="wave w-16 h-16 absolute rounded-full border-8 border-blue-300 animate-wave3"></div>
                                  <div className="wave w-18 h-18 absolute rounded-full border-8 border-blue-200 animate-wave4"></div>
                                </div>
                              </div>

                              <div className="bg-[#444D63E5] w-fit max-w-[80%] tri-right border_clip round btm-left-in   relative border-[#444D63] md:text-lg text-base text-white  rounded-br-lg p-3">
                                <p>
                                  {language == "HI"
                                    ? questions[6].hindistatement
                                    : questions[6].statement}
                                </p>
                              </div>
                            </div>
                            <div className="sm:order-2 order-1">
                              {!isSafari && (
                                <TextToSpeech
                                  text={questions[6].statement}
                                ></TextToSpeech>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="mx-auto text-center pt-4 ">
                          <div className="relative lg:w-fit-content mx-auto ">
                            <video
                              playsInline
                              ref={recordWebcam.previewRef}
                              className={
                                recordWebcam.status != "PREVIEW"
                                  ? "mx-auto  rounded-xl hidden h-[17rem]"
                                  : "mx-auto  rounded-xl h-[17rem]"
                              }
                              autoPlay
                              muted={status}
                              loop
                            />
                            <div className="mx-auto relative w-fit flex justify-center">
                              {recordWebcam.status !== "PREVIEW" && (
                                <video
                                  playsInline
                                  ref={recordWebcam.webcamRef}
                                  className="  rounded-xl h-[17rem]"
                                  autoPlay
                                  muted
                                />
                              )}
                              {recordWebcam.status == "OPEN" && (
                                <div className="absolute rounded-xl w-full h-full top-0 flex justify-center items-center text-white mx-auto left-1/2 -translate-x-1/2 right-0 px-6  bg-black bg-opacity-40">
                                  <div className="flex items-center justify-center">
                                    <p className="text-white lg:text-2xl text-xl font-semibold px-2 py-2 rounded-xl">
                                      {translations.instruction[language].s9}
                                      <br />
                                      <span
                                        className={
                                          counter <= 5 && counter > 0
                                            ? "text-red-500 lg:text-3xl text-2xl"
                                            : "text-white lg:text-3xl text-2xl"
                                        }
                                      >
                                        {counter < 10 ? `0${counter}` : counter}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* {recordWebcam.status == "RECORDING" && (
                            <p className="absolute top-0 text-white w-full mx-autp left-0 right-0">
                              {translations.instruction[language].s1}
                            </p>
                          )} */}
                          </div>
                          <div className="space-x-3 mt-4 flex flex-col gap-4 items-center justify-center">
                            {recordWebcam.status == "OPEN" && (
                              <button
                                onClick={recordWebcam.start}
                                className="bg-light-blue  flex gap-2 font-semibold text-base px-6 py-3 rounded-lg text-white"
                              >
                                <CiMicrophoneOn className="w-6 h-6" />{" "}
                                {translations.instruction[language].s2}
                              </button>
                            )}
                            {recordWebcam.status == "RECORDING" && (
                              <button
                                onClick={stop}
                                className="bg-light-blue px-6 py-3 rounded-xl text-white"
                              >
                                {translations.instruction[language].s3}
                              </button>
                            )}
                            {recordWebcam.status == "PREVIEW" && (
                              <div className="lg:space-x-3 lg:block lg:space-y-0 flex flex-col space-y-3">
                                <button
                                  onClick={() => {
                                    saveFile9();
                                    // setCounter(15)
                                    handleStepsProgress();
                                  }}
                                  className="bg-light-blue px-6 py-3 rounded-xl text-white"
                                >
                                  {translations.instruction[language].s5}
                                </button>
                              </div>
                            )}
                            {recordWebcam.status !== "PREVIEW" && (
                              <button
                                className="bg-transparent  rounded-xl "
                                onClick={recordWebcam.open}
                              >
                                {translations.instruction[language].s4}
                                {language == "HI" ? (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    यहाँ क्लिक करें
                                  </span>
                                ) : (
                                  <span className="text-base font-semibold text-light-blue">
                                    {" "}
                                    Click Here
                                  </span>
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {ques == 11 && (
                    <div className="w-full h-full relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      ></img>
                      <div className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover mb-6  rounded-xl  ">
                        {" "}
                        <Progressbar progress={progress} />
                      </div>
                      <div
                        className="lg:w-2/3 mx-3 lg:mx-auto rounded-xl bg-white bg-cover p-6"
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL + "/Rectangle6.png"
                          })`,
                        }}
                      >
                        <div className="flex bg-[#39435A] items-center space-x-3 px-3 py-3 rounded-xl">
                          <p className="bg-white rounded-full p-2 px-4 font-bold font-poppins">
                            8
                          </p>
                          <p className="text-white font-poppins">
                            {questions[7].statement}
                          </p>
                        </div>
                        <div className="mx-auto text-center pt-4 ">
                          <div className="relative lg:w-1/2 mx-auto">
                            <video
                              playsInline
                              ref={recordWebcam.previewRef}
                              className={
                                recordWebcam.status != "PREVIEW"
                                  ? "mx-auto my-4 rounded-xl hidden h-[17rem]"
                                  : "mx-auto my-4 rounded-xl h-19rem]"
                              }
                              autoPlay
                              muted={status}
                              loop
                            />
                            {recordWebcam.status !== "PREVIEW" && (
                              <video
                                playsInline
                                ref={recordWebcam.webcamRef}
                                className="mx-auto my-4 rounded-xl h-19rem] "
                                autoPlay
                                muted
                              />
                            )}
                            {recordWebcam.status == "RECORDING" && (
                              <p className="absolute top-0 text-white w-full mx-autp left-0 right-0">
                                {translations.instruction[language].s1}
                              </p>
                            )}
                            {recordWebcam.status == "OPEN" && (
                              <div className=" absolute top-0 text-white w-full mx-autp left-1/2 -translate-x-1/2 right-0 p-4">
                                <div className="flex items-center justify-center">
                                  <TbPlayerRecordFilled className="text-red-500 animate-pulse"></TbPlayerRecordFilled>
                                  <p className="bg-white text-red-500 px-1 py-1 rounded-xl">{`00:$<span className={counter <= 5 && counter > 0 ? "text-red-500" : "text-white"}>
          {counter}
        </span>`}</p>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="space-x-3 mt-4">
                            {recordWebcam.status == "OPEN" && (
                              <button
                                onClick={recordWebcam.start}
                                className="bg-green-500 px-6 py-3 rounded-xl text-white"
                              >
                                {translations.instruction[language].s2}
                              </button>
                            )}
                            {recordWebcam.status == "RECORDING" && (
                              <button
                                onClick={stop}
                                className="bg-light-blue px-6 py-3 rounded-xl text-white"
                              >
                                {translations.instruction[language].s3}
                              </button>
                            )}
                            {recordWebcam.status == "PREVIEW" && (
                              <div className="lg:space-x-3 lg:block lg:space-y-0 flex flex-col space-y-3">
                                <button
                                  onClick={() => {
                                    saveFile9();
                                    handleStepsProgress();
                                  }}
                                  className="bg-light-blue px-6 py-3 rounded-xl text-white"
                                >
                                  {translations.instruction[language].s5}
                                </button>
                              </div>
                            )}
                            <button
                              className="bg-transparent px-6 py-3 rounded-xl "
                              onClick={recordWebcam.open}
                            >
                              {translations.instruction[language].s4}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {ques == 14 && (
                    <div className="flex flex-col h-screen w-full items-center justify-center">
                      <div className="lg:w-2/3 mx-3 lg:mx-auto rounded-xl bg-white bg-cover py-4 px-3">
                        <p className="font-poppins font-semibold">
                          {translations.instruction[language].s7}
                        </p>
                        <p></p>
                      </div>
                    </div>
                  )}
                  {/* {ques != 13 &&
                  ques !== 12 &&
                  ques !== 13 &&
                  ques !== 0 &&
                  ques != 14 &&
                  ques != 15 &&
                  ques != 1 &&
                  ques != 20 &&
                  ques != -1 && (
                    <input
                      className="mt-4 bottom-0 w-full h-16 outline-none px-2 py-2"
                      placeholder="You can write your notes here"
                    ></input>
                  )} */}
                  {ques == 13 && (
                    <div className="w-full h-full relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto p-4 mb-4 pt-0"
                      ></img>
                      <div className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover mb-6  rounded-xl  ">
                        {" "}
                        <Progressbar progress={progress} />
                      </div>
                      <div
                        className="lg:w-2/3 flex flex-col border  mx-3 lg:mx-auto rounded-xl my-4 bg-white bg-cover p-4 sm:p-6"
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL + "/Rectangle6.png"
                          })`,
                        }}
                      >
                        <div className="flex flex-col sm:flex-row w-full  items-center  mb-4">
                          <p
                            className={`text-center  w-full  font-semibold md:text-3xl sm:text-2xl text-xl ${
                              prefLanguage != "EN" ? "ml-40" : ""
                            }`}
                          >
                            {translations.info[language].s8}
                          </p>
                          <Toggle
                            language={language}
                            setLanguage={setLanguage}
                            onColor="rgba(20, 142, 255, 1)"
                          />
                        </div>
                        <div className=" rounded-2xl border-2 bg-white border-slate-300">
                          {/* <p className="font-semibold bg-[#39435A] py-3 px-2 rounded-xl text-white"> */}
                          <p className="font-semibold flex justify-between p-6  rounded-xl ">
                            {translations.instruction[language].s7}
                          </p>
                          <div className=" border-t-2 border-slate-300"></div>
                          <div className="sm:p-6 p-4 flex flex-col gap-4">
                            <div className="flex w-full sm:flex-row flex-col  gap-4">
                              <div className="sm:w-1/2 w-full">
                                <p className="font-semibold">
                                  {
                                    translations.info[language]
                                      .currentNoticePeriod
                                  }{" "}
                                  <span className="text-red-500">*</span>
                                </p>
                                <input
                                  value={noticePeriod}
                                  pattern="[0-9]"
                                  onChange={(e) => {
                                    inputNum(e);
                                  }}
                                  autocapitalize="word"
                                  // style={{textTransform:"capitalize"}}
                                  placeholder={
                                    translations.info[language].inDays
                                  }
                                  className=" outline-none border px-2 py-2 rounded-lg mt-2 w-full"
                                ></input>
                              </div>
                              <div className="sm:w-1/2 w-full">
                                <p className="font-semibold">
                                  {
                                    translations.info[language]
                                      .approximateJoiningTime
                                  }
                                  <span className="text-red-500">*</span>
                                </p>
                                <input
                                  value={joiningTime}
                                  onChange={(e) => {
                                    approxNum(e);
                                  }}
                                  placeholder={
                                    translations.info[language].inDays
                                  }
                                  className="border outline-none  px-1 py-2 rounded-lg mt-2 w-full"
                                ></input>
                              </div>
                            </div>
                            <div className="flex w-full sm:flex-row flex-col  gap-4">
                              <div className="sm:w-1/2 w-full">
                                <p className="font-semibold">
                                  {
                                    translations.info[language]
                                      .currentMonthlySalary
                                  }{" "}
                                  <span className="text-red-500">*</span>
                                </p>
                                <div className="flex gap-2 items-center justify-between">
                                  <select
                                    value={curr}
                                    disabled
                                    className="border px-2  py-2 w-[6rem] sm:w-[7rem] outline-none rounded-lg mt-2 "
                                  >
                                    <option value={curr}>{curr}</option>
                                    {/* Keeping historical options for reference/structure, though disabled */}
                                    <option value="INR">INR</option>
                                    <option value="USD">USD</option>
                                    <option value="EUR">EUR</option>
                                    <option value="GBP">GBP</option>
                                    <option value="AUD">AUD</option>
                                    <option value="CAD">CAD</option>
                                    <option value="SGD">SGD</option>
                                    <option value="AED">AED</option>
                                  </select>
                                  <input
                                    value={currentSalary}
                                    placeholder="xx,xxx"
                                    onChange={(e) => {
                                      monthlySalary(e);
                                    }}
                                    autocapitalize="word"
                                    className=" outline-none border px-2 py-2 rounded-lg mt-2 w-full"
                                  ></input>
                                </div>
                              </div>
                              <div className="sm:w-1/2 w-full">
                                <p className="font-semibold">
                                  {
                                    translations.info[language]
                                      .expectedMonthlySalary
                                  }
                                  <span className="text-red-500">*</span>
                                </p>
                                <input
                                  value={expectedSalary}
                                  placeholder="xx,xxx"
                                  onChange={(e) => {
                                    expectedMSalary(e);
                                  }}
                                  className="border   px-2 py-2 rounded-lg mt-2 w-full"
                                ></input>
                              </div>
                            </div>
                            <div>
                              <p className=" font-semibold">
                                {translations.info[language].additionalInfo}
                              </p>
                              <textarea
                                rows="4"
                                value={notes}
                                placeholder={
                                  translations.info[language].addMessage
                                }
                                onChange={(e) => {
                                  setNotes(e.target.value);
                                }}
                                className="border mt-2  p-3 rounded-lg  w-full"
                              ></textarea>
                            </div>
                          </div>

                          {/* <p className="text-white font-poppins">{questions[7].statement}</p> */}
                        </div>
                      </div>

                      <div className="sm:m-auto w-full !mt-6 fixed bottom-4 md:bottom-0 sm:w-fit md:relative md:left-0  left-1/2 -translate-x-1/2 md:-translate-x-0">
                        <div className="flex justify-between w-full">
                          <button
                            disabled={
                              !(
                                expectedSalary &&
                                currentSalary &&
                                noticePeriod &&
                                joiningTime
                              )
                            }
                            onClick={() => {
                              patchUser();
                              handleStepsProgress();
                            }}
                            className={
                              expectedSalary &&
                              currentSalary &&
                              noticePeriod &&
                              joiningTime
                                ? "bg-light-blue text-white max-w-96 sm:w-96 w-[90%] min-w-44 py-3 rounded-xl mx-auto"
                                : " bg-gray-400 text-white max-w-96 sm:w-96 w-[90%] min-w-44 py-3 rounded-xl mx-auto"
                            }
                          >
                            {translations.info[language].saveAndNext}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {ques == 12 && (
                    <div className="w-full h-full relative">
                      <img
                        src={logo}
                        className="lg:h-28 h-20 m-auto mt-2 p-4 pt-0"
                      ></img>
                      <div className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover mb-6  rounded-xl  ">
                        {" "}
                        <Progressbar progress={progress} />
                      </div>
                      <div className="relative space-y-10 ">
                        {/* {
            visibleVideo2 &&
          <div className="fixed bottom-16 z-20 md:bottom-4 right-6 ">
            <video src={end} className="rounded-xl h-[10rem] md:h-[16rem] transition-all hover:h-[30rem]" controls playsInline autoPlay muted></video>
            <button onClick={()=>{setVisibleVideo2(false)}}>
            <div className="absolute top-0 right-0 bg-black text-white text-lg rounded-full p-2 -mr-4 -mt-4">
              <RxCross1></RxCross1>
            </div>
            </button>
          </div>
          } */}
                        <div className="">
                          <div
                            className="lg:w-2/3  sm:w-[85%] w-full mx-auto bg-cover   rounded-xl p-6 lg:px-12"
                            style={{
                              backgroundImage: `url(${
                                process.env.PUBLIC_URL + "/Rectangle6.png"
                              })`,
                            }}
                          >
                            <div className="text-center my-5 font- font-poppins lg:text-2xl lg:leading-10">
                              <div className="flex justify-center md:justify-end text-base md:mb-0 mb-4">
                                <Toggle
                                  language={language}
                                  setLanguage={setLanguage}
                                  onColor="rgba(20, 142, 255, 1)"
                                />
                              </div>
                              <span className="md:text-xl text-lg">
                                {translations.info[language].s3}
                              </span>
                              <br></br>
                              {translations.info[language].s4}
                              <br></br>
                            </div>
                            {!isRated ? (
                              <div className="">
                                <div className="">
                                  {/* <p className="bg-white rounded-full p-2 px-4 font-bold font-poppins">1</p> */}
                                  <p className="mt-5 font-poppins text-center py-2">
                                    {translations.info[language].s5}
                                  </p>
                                </div>
                                <div className="flex w-full justify-center">
                                  <ReactStars
                                    count={5}
                                    className="text-center flex justify-center items-center bg-gray-300 rounded-xl px-3"
                                    value={star}
                                    onChange={(e) => {
                                      setStar(e);
                                      if (e <= 3) {
                                        setShowTextarea(true);
                                      } else {
                                        setShowTextarea(false);
                                      }
                                    }}
                                    isHalf={false}
                                    half={false}
                                    edit={true}
                                    size={40}
                                    color1={"#FFFFFF"}
                                  ></ReactStars>
                                </div>
                                {showTextarea && (
                                  <div className="flex w-full justify-center">
                                    <textarea
                                      className="mt-4 p-3 border border-gray-300 rounded-xl"
                                      style={{ width: "40%" }}
                                      placeholder={
                                        translations.info[language].s7
                                      }
                                      value={textareaContent}
                                      onChange={(event) =>
                                        setTextareaContent(event.target.value)
                                      }
                                      rows={4}
                                    ></textarea>
                                  </div>
                                )}
                                <button
                                  onClick={() => {
                                    saveStar();
                                  }}
                                  className="bg-light-blue mt-5 text-white w-full py-3 rounded-xl"
                                >
                                  {translations.info[language].saveAndNext}
                                </button>
                              </div>
                            ) : (
                              <div>
                                <p className="mt-10 font-poppins text-center py-2">
                                  {translations.info[language].s6}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="px-4">
                  <Copyright />
                </div>
              </div>
            )}
          </div>
        ) : (
          <div
            className="bg-cover min-h-screen flex flex-col sm:p-5 p-4 md:!pb-0 !pb-20 "
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL + "/Bg.png"})`,
            }}
          >
            <img src={logo} className="lg:h-28 h-20 m-auto mb-4 p-4 pt-0"></img>
            <div className="relative  md:flex-grow">
              {/* {
            visibleVideo2 &&
          <div className="fixed bottom-16 z-20 md:bottom-4 right-6 ">
            <video src={end} className="rounded-xl h-[10rem] md:h-[16rem] transition-all hover:h-[30rem]" controls playsInline autoPlay muted></video>
            <button onClick={()=>{setVisibleVideo2(false)}}>
            <div className="absolute top-0 right-0 bg-black text-white text-lg rounded-full p-2 -mr-4 -mt-4">
              <RxCross1></RxCross1>
            </div>
            </button>
          </div>
          } */}
              <div className="">
                <div
                  className="lg:w-2/3 mx-3 lg:mx-auto bg-cover   rounded-xl py-4 px-4 lg:px-12"
                  style={{
                    backgroundImage: `url(${
                      process.env.PUBLIC_URL + "/Rectangle6.png"
                    })`,
                  }}
                >
                  <div className="text-center my-10 font font-poppins  lg:leading-10">
                    <span className="lg:text-3xl sm:text:2xl text:lg">
                      The link has expired or has already been used.
                    </span>
                    <br></br>
                  </div>
                </div>
              </div>

              <div></div>
            </div>

            <div className="px-4">
              <Copyright />
            </div>
          </div>
        )}
      </div>
    );
}

export default Data;
